// (function () {
//   'use strict';

//   var KEYS = 'ABCDEF';

//   var ENGINE = {
//     chairs: {
//       scores: {
//         who: { me: { bliss: 1, apollo: 2, davinci: 1, zeus: 1 }, partner: { therapi: 2, davinci: 1, robo: 1, zeus: 1 }, household: { therapi: 2, zeus: 2, robo: 2 }, gift: { therapi: 3, bliss: 1 }, work: { zeus: 2, robo: 2, apollo: 1 } },
//         goal: { aches: { therapi: 3, apollo: 2, davinci: 1, zeus: 1 }, sport: { zeus: 3, apollo: 2, robo: 1 }, destress: { bliss: 2, davinci: 2, therapi: 1 }, sleep: { bliss: 3, therapi: 2 }, posture: { apollo: 3, robo: 2, zeus: 1 }, all: { davinci: 2, robo: 2, zeus: 1, therapi: 1 } },
//         focus: { neck: { therapi: 1, apollo: 1, bliss: 1 }, back: { apollo: 2, therapi: 1, davinci: 1 }, legs: { zeus: 2, therapi: 1, robo: 1 }, arms: { zeus: 3, robo: 2, davinci: 1 }, full: { robo: 2, davinci: 2, zeus: 1 } },
//         intensity: { gentle: { bliss: 2, therapi: 2, robo: 1 }, firm: { therapi: 1, apollo: 1, davinci: 1, zeus: 1 }, deep: { davinci: 3, apollo: 2, zeus: 2 }, varies: { robo: 2, davinci: 1, bliss: 1 } },
//         space: { compact: { bliss: 3, davinci: 1 }, living: { therapi: 1, apollo: 1, zeus: 1 }, dedicated: { robo: 2, davinci: 2, zeus: 1 } },
//         priority: { power: { davinci: 2, zeus: 2, apollo: 1 }, tech: { robo: 3, davinci: 2, bliss: 1 }, design: { davinci: 3, robo: 2, bliss: 1 }, simple: { therapi: 3, bliss: 1 }, value: { bliss: 3, therapi: 2 } }
//       },
//       budget: {
//         b1: { bliss: 1.35, therapi: 1.1, apollo: 0.75, zeus: 0.55, davinci: 0.5, robo: 0.45 },
//         b2: { bliss: 1, therapi: 1.25, apollo: 1.25, zeus: 0.9, davinci: 0.75, robo: 0.65 },
//         b3: { bliss: 0.7, therapi: 0.85, apollo: 1, zeus: 1.2, davinci: 1.2, robo: 1.25 },
//         b0: { bliss: 1, therapi: 1, apollo: 1, zeus: 1, davinci: 1, robo: 1 }
//       },
//       reasons: {},
//       meta: {
//         giftTitle: false,
//         noun: 'your Olympia.',
//         cta2: 'Book a Demo',
//         tag0: 'Your best match ★',
//         tag1: 'A close second',
//         sentLabel: 'Results sent to',
//         restartLabel: 'Retake the quiz',
//         emailTitle: 'Where should we send your match?',
//         okEmail: 'See my match',
//         errEmail: '⚠ A valid email is needed to send the results.',
//         errSelect: '⚠ Please make a selection to continue.',
//         emailNote: 'Your personalised recommendation is ready — your top two chairs, why they fit, and current pricing. Enter an email to view and receive the results.',
//         rSub: 'Two chairs rose to the top of your answers. Both carry the 60 day feel great guarantee and the 5 year platinum warranty, so the choice between them is about how you want to feel.',
//         assure: ['60 day guarantee', '5 year platinum warranty', 'Free delivery']
//       }
//     },
//     saunas: {
//       scores: {
//         today: { facility: { classic: 2, genesis: 2 }, appointments: { genesis: 1, capsule: 1 }, diy: { capsule: 1, solus: 1 }, nothing: { solus: 2, capsule: 1 } },
//         friction: { cost: { genesis: 1, classic: 1 }, consistency: { capsule: 2, solus: 2 }, fades: { genesis: 1, capsule: 1 }, public: { classic: 2, genesis: 2 }, nothing_yet: { solus: 2 } },
//         signal: { sore: { genesis: 2, classic: 1 }, wired: { classic: 1, genesis: 1, solus: 1 }, flat: { capsule: 1, solus: 1, genesis: 1 }, skin: { genesis: 2, capsule: 1 }, stress: { classic: 1, genesis: 1 } },
//         ritual: { steamritual: { classic: 4 }, immersive: { genesis: 3 }, quickreset: { capsule: 2, solus: 2 }, outdoors: { genesis: 3 } },
//         who: { me: { solus: 2, capsule: 2, genesis: 1 }, partner: { genesis: 2, classic: 2 }, household: { classic: 3, genesis: 2 }, gift: { solus: 2, capsule: 2, classic: 1 } },
//         space: { corner: { capsule: 2, solus: 2, classic: 1, genesis: 1 }, dedicated: { genesis: 2, classic: 2 }, outdoor: { genesis: 3 }, minimal: { solus: 3, capsule: 2 } }
//       },
//       budget: {
//         b1: { genesis: 0.3, classic: 0.35, capsule: 0.6, solus: 1.5 },
//         b2: { genesis: 0.5, classic: 0.6, capsule: 1.45, solus: 1.1 },
//         b3: { genesis: 1.2, classic: 1.3, capsule: 0.75, solus: 0.6 },
//         b4: { genesis: 1.35, classic: 1.15, capsule: 0.55, solus: 0.5 },
//         b0: { genesis: 1, classic: 1, capsule: 1, solus: 1 }
//       },
//       reasons: {},
//       meta: {
//         giftTitle: false,
//         noun: 'your sanctuary.',
//         cta2: 'Book a viewing',
//         tag0: 'Your best match ★',
//         tag1: 'A close second',
//         sentLabel: 'Results sent to',
//         restartLabel: 'Retake the quiz',
//         emailTitle: 'Where should we send your match?',
//         okEmail: 'See my match',
//         errEmail: '⚠ A valid email is needed to send the results.',
//         errSelect: '⚠ Please make a selection to continue.',
//         emailNote: 'Your personalised recommendation is ready — your top two saunas, why they fit, and current pricing. Enter an email to view and receive the results.',
//         rSub: 'Two saunas rose to the top of your answers. Both are professionally delivered and installed and carry the 5 year platinum warranty, so the choice between them is about how you want your ritual to feel.',
//         assure: ['5 year platinum warranty', 'Professional install', 'Australian support']
//       }
//     },
//     gift: {
//       scores: {
//         who: { partner: { halo: 1, calmcloud: 1, otto: 1, plushpro: 1 }, parent: { otto: 2, plushpro: 2, comfycloud: 1, plushmini: 1, axo: 1 }, friend: { oropebble: 1, spaluxe: 1, halo: 1, plushmini: 1 }, colleague: { spaluxe: 2, oropebble: 1, plushmini: 1, calmcloud: 1 }, anyone: { halo: 1, healios: 1, comfycloud: 1, spaluxe: 1 } },
//         occasion: { bday: { plushmini: 1, halo: 1 }, xmas: { otto: 1, healios: 1, plushpro: 1 }, romance: { halo: 2, calmcloud: 1, spaluxe: 1 }, thanks: { spaluxe: 1, oropebble: 1, plushmini: 1 }, justbc: { spaluxe: 1, comfycloud: 1 } },
//         needs: { neckshoulders: { calmcloud: 2, comfycloud: 2, plushmini: 1, plushpro: 1 }, feet: { otto: 3, axo: 2, healios: 1 }, training: { oroarc: 3, healios: 2, healiosplus: 2, oropebble: 1, axo: 1 }, screens: { halo: 3, spaluxe: 2 }, sleep: { halo: 2, spaluxe: 1, comfycloud: 1, calmcloud: 1 }, pamper: { spaluxe: 1, halo: 1, otto: 1, plushpro: 1 } },
//         days: { desk: { plushmini: 2, calmcloud: 1, halo: 1, plushpro: 1 }, onfeet: { otto: 2, axo: 2, healios: 1 }, active: { oroarc: 2, healios: 2, healiosplus: 2, oropebble: 1 }, home: { otto: 1, plushpro: 1, comfycloud: 1 }, travel: { oropebble: 2, spaluxe: 1, calmcloud: 1, halo: 1 } },
//         style: { practical: { oroarc: 1, plushmini: 1, calmcloud: 1, otto: 1 }, luxe: { halo: 2, healiosplus: 2, plushpro: 1 }, statement: { otto: 2, healiosplus: 3, healios: 1, axo: 1, plushpro: 1 }, compact: { spaluxe: 2, oropebble: 2, plushmini: 1, halo: 1 } }
//       },
//       budget: {
//         b1: { spaluxe: 1.5, oropebble: 1.5, calmcloud: 1.35, oroarc: 1.35, halo: 0.7, comfycloud: 0.7, plushmini: 0.7, plushpro: 0.35, otto: 0.3, axo: 0.25, healios: 0.15, healiosplus: 0.12 },
//         b2: { halo: 1.4, comfycloud: 1.4, plushmini: 1.4, calmcloud: 1.1, oroarc: 1.1, spaluxe: 0.9, oropebble: 0.9, plushpro: 0.6, otto: 0.5, axo: 0.4, healios: 0.25, healiosplus: 0.2 },
//         b3: { plushpro: 1.4, otto: 1.4, axo: 1.35, halo: 0.6, comfycloud: 0.6, plushmini: 0.6, healios: 0.6, healiosplus: 0.45, calmcloud: 0.5, oroarc: 0.5, spaluxe: 0.4, oropebble: 0.4 },
//         b4: { healios: 1.5, healiosplus: 1.5, axo: 0.9, otto: 0.8, plushpro: 0.6, halo: 0.4, comfycloud: 0.4, plushmini: 0.4, calmcloud: 0.35, oroarc: 0.35, spaluxe: 0.3, oropebble: 0.3 },
//         b0: { spaluxe: 1, halo: 1, oropebble: 1, oroarc: 1, calmcloud: 1, comfycloud: 1, otto: 1, axo: 1, plushmini: 1, plushpro: 1, healios: 1, healiosplus: 1 }
//       },
//       reasons: {},
//       meta: {
//         giftTitle: true,
//         noun: 'sorted.',
//         cta2: 'See all portables',
//         tag0: 'The gift ★',
//         tag1: 'The backup plan',
//         sentLabel: 'Shortlist sent to',
//         restartLabel: 'Find another gift',
//         emailTitle: 'Where should we send the gift shortlist?',
//         okEmail: 'See the picks',
//         errEmail: '⚠ A valid email is needed to send the shortlist.',
//         errSelect: '⚠ Please make a selection to continue.',
//         emailNote: 'The top two gift picks, with current pricing and links, sent straight to the inbox. It also makes a very effective forwardable hint.',
//         rSub: 'Two picks rose to the top of the answers. Both ship free to every Australian postcode with 30 day money back, so the safe move is the confident one.',
//         assure: ['Free shipping Australia wide', '30 day money back', '50,000+ happy customers']
//       }
//     }
//   };

//   function ProductQuiz(root) {
//     this.root = root;
//     this.config = mergeConfig(readQuizConfig());
//     this.state = { category: null, step: 0, answers: {}, email: '', firstName: '', phone: '', done: false, err: false };
//     this.cacheDom();
//     this.bindEvents();
//   }

//   var CDN = 'https://cdn.shopify.com/s/files/1/0751/6425/4488/files/';

//   function readQuizConfig() {
//     var el = document.getElementById('olympia-quiz-config');
//     if (el && el.textContent) {
//       try {
//         return JSON.parse(el.textContent);
//       } catch (err) {
//         console.error('Olympia quiz: invalid config JSON', err);
//       }
//     }
//     return window.QuizConfig || {};
//   }

//   function mergeConfig(cfg) {
//     var out = { quizzes: {}, stages: {}, products: {}, meta: cfg.meta || {}, editorPreview: cfg.editorPreview || 'none' };
//     ['saunas', 'chairs', 'gift'].forEach(function (k) {
//       var fromBlocks = (cfg.quizzes && cfg.quizzes[k] && cfg.quizzes[k].length) ? cfg.quizzes[k] : null;
//       out.quizzes[k] = fromBlocks || DEFAULTS.quizzes[k] || [];
//       var blockStages = (cfg.stages && cfg.stages[k] && cfg.stages[k].length) ? cfg.stages[k] : [];
//       var defaults = DEFAULTS.stages[k] || [];
//       out.stages[k] = out.quizzes[k].map(function (q, idx) {
//         return (q.stageImage && q.stageImage.length) ? q.stageImage : (blockStages[idx] || defaults[idx] || defaults[defaults.length - 1] || '');
//       });
//       out.products[k] = Object.assign({}, DEFAULTS.products[k] || {}, (cfg.products && cfg.products[k]) || {});
//     });
//     out.designMode = cfg.designMode || false;
//     out.editorPreview = cfg.editorPreview || 'none';
//     out.adminEmail = cfg.adminEmail || '';
//     out.emailSubject = cfg.emailSubject || 'Olympia Quiz Submission';
//     return out;
//   }

//   var DEFAULTS = {
//     quizzes: {
//       chairs: [
//         { id: 'who', title: "Who's this chair for?", options: [{ id: 'me', label: 'Just me' }, { id: 'partner', label: 'Me and my partner' }, { id: 'household', label: 'The whole household' }, { id: 'gift', label: 'A gift for someone special' }, { id: 'work', label: 'A workplace or practice' }] },
//         { id: 'goal', title: 'What should it do for you, above all?', options: [{ id: 'aches', label: 'Ease everyday aches and pains' }, { id: 'sport', label: 'Recover from sport and training' }, { id: 'destress', label: 'Help me switch off and de-stress' }, { id: 'sleep', label: 'Improve my sleep' }, { id: 'posture', label: 'Undo desk posture and tension' }, { id: 'all', label: 'A bit of everything' }] },
//         { id: 'focus', title: 'Where does your body need it most?', help: 'Choose as many as you like', multi: true, options: [{ id: 'neck', label: 'Neck and shoulders' }, { id: 'back', label: 'Lower back' }, { id: 'legs', label: 'Legs and feet' }, { id: 'arms', label: 'Arms and hands' }, { id: 'full', label: 'Head to toe' }] },
//         { id: 'intensity', title: 'How strong do you like a massage?', options: [{ id: 'gentle', label: 'Gentle and soothing' }, { id: 'firm', label: 'Firm and balanced' }, { id: 'deep', label: 'Deep and powerful' }, { id: 'varies', label: 'Depends on the day' }] },
//         { id: 'space', title: 'Where will it live?', options: [{ id: 'compact', label: 'A compact corner', sub: 'Apartment friendly, tidy footprint' }, { id: 'living', label: 'The living room', sub: 'It should earn its place' }, { id: 'dedicated', label: 'A dedicated wellness space', sub: 'Statement pieces welcome' }] },
//         { id: 'priority', title: 'What matters most in the decision?', options: [{ id: 'power', label: 'Massage power' }, { id: 'tech', label: 'The smartest technology' }, { id: 'design', label: 'Design that turns heads' }, { id: 'simple', label: 'Simple for everyone to use' }, { id: 'value', label: 'Value for money' }] },
//         { id: 'budget', title: 'What budget do you have in mind?', options: [{ id: 'b1', label: '$$', sub: 'Quality relief around $5,000' }, { id: 'b2', label: '$$$', sub: 'Room to move, $7,000 to $9,000' }, { id: 'b3', label: '$$$$', sub: 'All in, $10,000 and beyond' }, { id: 'b0', label: 'Not sure yet', sub: 'Show the best match regardless' }] }
//       ],
//       saunas: [
//         { id: 'today', title: 'How do you recover right now?', options: [{ id: 'facility', label: 'Sauna or ice bath sessions somewhere else', sub: 'A gym, bathhouse or recovery studio' }, { id: 'appointments', label: 'Massage, physio or spa appointments' }, { id: 'diy', label: 'Hot showers, stretching, winging it' }, { id: 'nothing', label: "There's no real routine", sub: "That's kind of the problem" }] },
//         { id: 'friction', title: "What's not working about that?", options: [{ id: 'cost', label: 'The costs never stop', sub: 'Memberships, sessions, bookings' }, { id: 'consistency', label: 'Staying consistent', sub: 'Life keeps getting in the way' }, { id: 'fades', label: 'It helps, but it never lasts' }, { id: 'public', label: 'Sharing a sauna with strangers', sub: 'Not exactly relaxing' }, { id: 'nothing_yet', label: "There's nothing in place to fix yet" }] },
//         { id: 'signal', title: 'Where is it showing up for you?', help: 'Choose as many as you like', multi: true, options: [{ id: 'sore', label: 'Tight and sore after training' }, { id: 'wired', label: 'Wired at night, hard to switch off' }, { id: 'flat', label: 'Run down, low on energy' }, { id: 'skin', label: 'Skin, circulation, puffiness' }, { id: 'stress', label: 'Carrying stress everywhere' }] },
//         { id: 'stakes', title: 'And if nothing changes this year?', options: [{ id: 'spend', label: 'More memberships and appointments to pay for' }, { id: 'nights', label: 'More flat mornings and restless nights' }, { id: 'slipping', label: 'Recovery keeps sliding down the list' }, { id: 'browsing', label: 'Honestly, just browsing for now' }] },
//         { id: 'ritual', title: "Picture the perfect end to your day. What's happening?", options: [{ id: 'steamritual', label: 'Deep heat, rolling steam, a proper sweat', sub: 'Then the cold shower' }, { id: 'immersive', label: 'Warm light, music playing, thirty unhurried minutes' }, { id: 'quickreset', label: 'Twenty minutes of heat, then back to life' }, { id: 'outdoors', label: 'Heat therapy on the deck as the sun goes down' }] },
//         { id: 'who', title: 'Who else will be stealing sessions?', options: [{ id: 'me', label: "No one. This one's mine" }, { id: 'partner', label: 'My partner, guaranteed' }, { id: 'household', label: 'The whole household will line up' }, { id: 'gift', label: "It's a gift for someone special" }] },
//         { id: 'space', title: 'Where do you see it living?', options: [{ id: 'corner', label: 'A spare corner indoors' }, { id: 'dedicated', label: 'A dedicated spot indoors' }, { id: 'outdoor', label: 'Outdoors, deck or garden' }, { id: 'minimal', label: 'As little space as possible' }] },
//         { id: 'budget', title: 'If the right sauna ended that cycle, what were you prepared to invest?', options: [{ id: 'b1', label: '$', sub: 'Under $1,500' }, { id: 'b2', label: '$$', sub: '$1,500 to $3,500' }, { id: 'b3', label: '$$$', sub: '$3,500 to $6,000' }, { id: 'b4', label: '$$$$', sub: '$6,000 and beyond' }, { id: 'b0', label: 'Not sure yet', sub: 'Show the match first' }] }
//       ],
//       gift: [
//         { id: 'who', title: "Who's the gift for?", options: [{ id: 'partner', label: 'My partner' }, { id: 'parent', label: 'Mum, Dad or a grandparent' }, { id: 'friend', label: 'A friend or sibling' }, { id: 'colleague', label: 'A colleague or client' }, { id: 'anyone', label: 'The person who has everything' }] },
//         { id: 'occasion', title: "What's the occasion?", options: [{ id: 'bday', label: 'Birthday' }, { id: 'xmas', label: 'Christmas' }, { id: 'romance', label: "Anniversary or Valentine's" }, { id: 'thanks', label: 'Thank you or congratulations' }, { id: 'justbc', label: 'Just because' }] },
//         { id: 'needs', title: 'What do they mention most?', help: 'Choose as many as you like', multi: true, options: [{ id: 'neckshoulders', label: 'A stiff neck and tight shoulders' }, { id: 'feet', label: 'Sore feet and legs by evening' }, { id: 'training', label: 'Muscle soreness from the gym or sport' }, { id: 'screens', label: 'Tired eyes and too much screen time' }, { id: 'sleep', label: 'Trouble winding down at night' }, { id: 'pamper', label: 'Nothing specific, they love being pampered' }] },
//         { id: 'days', title: 'Where do their days mostly happen?', options: [{ id: 'desk', label: 'At a desk' }, { id: 'onfeet', label: 'On their feet' }, { id: 'active', label: 'Training or playing sport' }, { id: 'home', label: 'Around the home' }, { id: 'travel', label: 'On the road or travelling' }] },
//         { id: 'style', title: 'What kind of gift lands best with them?', options: [{ id: 'practical', label: 'Practical, something used daily' }, { id: 'luxe', label: "A little luxury they'd never buy themselves" }, { id: 'statement', label: 'A statement under the wrapping paper' }, { id: 'compact', label: 'Small, neat, easy to wrap or post' }] },
//         { id: 'budget', title: "What's the gift budget?", options: [{ id: 'b1', label: '$', sub: 'Under $150' }, { id: 'b2', label: '$$', sub: '$150 to $300' }, { id: 'b3', label: '$$$', sub: '$300 to $600' }, { id: 'b4', label: '$$$$', sub: '$600 and beyond' }, { id: 'b0', label: 'Flexible', sub: 'For the right gift' }] }
//       ]
//     },
//     stages: {
//       saunas: [
//         CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
//         CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
//         CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
//         CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
//         CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
//         CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
//         CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
//         CDN + 'uploads_CTA_Images___jpg.jpg?v=1784618120'
//       ],
//       chairs: [
//         CDN + 'Product_Categories_Top_Section.jpg?v=1784618120',
//         CDN + 'Therapi_-_V7.3.jpg?v=1784618120',
//         CDN + 'Product_Categories_Top_Section.jpg?v=1784618120',
//         CDN + 'Product_Categories_Top_Section.jpg?v=1784618120',
//         CDN + 'Product_Categories_Top_Section.jpg?v=1784618120',
//         CDN + 'Product_Categories_Top_Section.jpg?v=1784618120',
//         CDN + 'uploads_CTA_Images___jpg.jpg?v=1784618120'
//       ],
//       gift: [
//         CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120',
//         CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120',
//         CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120',
//         CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120',
//         CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120',
//         CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120'
//       ]
//     },
//     products: {
//       chairs: {
//         bliss: { name: 'Bliss XO', panel: '#5C7189', img: '', was: '$9,900', now: '$4,900', weekly: '$34/wk', url: 'https://olympia.au/products/bliss-xo-massage-chair', tagline: "Where modern tech meets infinite comfort. Compact, stylish, and the range's best seller.", defaults: ['4D quad rollers on a flexible SL track, from neck to hamstrings.', 'Space-saving footprint that suits apartments and smaller rooms.', 'Dedicated sleep programs, voice control and zero gravity recline.'] },
//         therapi: { name: 'Therapi +', panel: '#175A48', img: '', was: '$13,900', now: '$6,900', weekly: '$48/wk', url: 'https://olympia.au/products/therapi-massage-chair', tagline: 'Heal, soothe and restore. The therapeutic all-rounder the whole household fights over.', defaults: ['Ergonomic stretching and percussion therapy for everyday aches.', 'Heated seat, voice control and built-in speakers, all simple to drive.', "The range's proven family favourite, loved across every age."] },
//         apollo: { name: 'Apollo X', panel: '#9C9C9A', img: '', was: '$18,900', now: '$8,900', weekly: '$62/wk', url: 'https://olympia.au/products/apollo-x-massage-chair', tagline: 'Health enhancement built into your lifestyle. Deep tissue strength for people who push hard.', defaults: ['Serious deep tissue power with a heated seat for desk-tight backs.', 'Postural stretching across eight apex points to undo the workday.', '4D quad rollers with weightless zero gravity recline.'] },
//         zeus: { name: 'Zeus Athletica', panel: '#A99C8B', img: '', was: '$21,900', now: '$10,900', weekly: '$76/wk', url: 'https://olympia.au/products/zeus-athletica-massage-chair', tagline: 'Unrivalled in features, unmatched in luxury. Built for performance and recovery.', defaults: ['Mechanical deep-tissue arm rollers, elbow to palm. A range first.', 'Dual system rollers and leg stretching tuned for active recovery.', 'SmartGuard motion sensing keeps small children and pets safe.'] },
//         davinci: { name: 'DaVinci', panel: '#1E3A5F', img: '', was: '$23,900', now: '$11,900', weekly: '$83/wk', url: 'https://olympia.au/products/davinci-massage-chair', tagline: 'Natural healing meets scientific innovation, in a body designed by ItalDesign.', defaults: ['Sculpted by ItalDesign, the studio behind legendary automotive icons.', 'AI Health Scanner reads body composition and fatigue before each session.', 'High-torque quad rollers with music-synchronised massage programs.'] },
//         robo: { name: 'ROBO', panel: '#141414', img: '', was: '$27,900', now: '$13,900', weekly: '$96/wk', url: 'https://olympia.au/products/robo-massage-chair', tagline: 'The flagship. Japanese craftsmanship, robotic precision and timeless design.', defaults: ['Robotic hand and leg massagers with patented dual-action rollers.', 'Facial recognition remembers up to eight users and their settings.', 'Full flat-lay position for spinal decompression and deep recovery.'] }
//       },
//       saunas: {
//         genesis: { name: 'Genesis', kind: 'Infrared Sauna', panel: '#33302B', img: '', priceLabel: 'From $4,900', priceSub: '2, 3 or 4 person', url: 'https://www.olympiasaunas.com.au/products/olympia-genesis', tagline: 'The latest in infrared therapy. A full-spectrum sanctuary with smart controls, therapeutic lighting and integrated audio.', defaults: ['Full-spectrum infrared: near, mid and far wavelengths in one cabin.', '8 low-EMF carbon heaters plus 2 full-spectrum heaters for even, deep warmth.', 'Plugs into a standard 10A socket. No electrician required.'] },
//         classic: { name: 'Classic', kind: 'Steam Sauna', panel: '#6E5641', img: '', priceLabel: 'From $3,900', priceSub: '1 to 4 person', url: 'https://www.olympiasaunas.com.au/products/olympia-classic', tagline: 'The traditional sauna experience. Rolling steam, deep enveloping heat and a Harvia heater at the centre of the ritual.', defaults: ['Authentic high heat and humidity, the sauna as it has been practised for generations.', 'A reliable Harvia heater and premium Canadian Hemlock timber.', 'The pick for shared, social, spa-style sessions.'] },
//         capsule: { name: 'Capsule', kind: 'Sauna Bath', panel: '#8B7355', img: '', priceLabel: '$2,900', priceSub: 'Single seat capsule', url: 'https://www.olympiasaunas.com.au/products/olympia-capsule', tagline: 'A compact half-body infrared capsule. The enclosed sauna feeling without giving up a room.', defaults: ['Enclosed seating concentrates infrared warmth around the body.', 'A space-saving footprint that fits where a cabin never could.', 'Simple to use for an effective daily infrared session.'] },
//         solus: { name: 'Solus', kind: 'Infrared Therapy Chair', panel: '#3F5866', img: '', priceLabel: '$990', priceSub: '475mm wide · 28kg', url: 'https://www.olympiasaunas.com.au/products/solus', tagline: 'A personal infrared wellness chair. Restorative heat in the lightest, most flexible form in the range.', defaults: ['Infrared heating through the base and back in an ergonomic seated design.', 'Ultra-compact and lightweight enough to move room to room.', 'The most accessible way into daily infrared therapy.'] }
//       },
//       gift: {
//         spaluxe: { name: 'Spa Luxe', kind: 'Head Massager', panel: '#7A6A57', img: '', was: '$150', now: '$95', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/spa-luxe-head-massager', tagline: 'A handheld scalp and head massager for instant, anywhere relaxation.', defaults: ['The most giftable price point in the range at $95.', 'Small enough to wrap, post, and use anywhere.', 'A crowd-safe pick: no sizing, no setup, instant effect.'] },
//         halo: { name: 'HALO+', kind: 'Eye Massager', panel: '#4A4E58', img: '', was: '$290', now: '$190', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/halo-eye-massager', tagline: 'A wearable eye massager built for screen-tired eyes and wind-down routines.', defaults: ['Made for the person who ends every day in front of a screen.', 'A pamper-level gift that still gets daily use.', '$190 against a $290 RRP.'] },
//         oropebble: { name: 'ORO Pebble', kind: 'Massage Gun', panel: '#5F5F5B', img: '', was: '$150', now: '$95', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/oro-pebble-massage-gun', tagline: 'A palm-sized percussive massage gun that travels anywhere.', defaults: ["Pocketable percussive relief at the range's entry price.", 'Fits a gym bag, carry-on or desk drawer.', '$95 against a $150 RRP.'] },
//         oroarc: { name: 'ORO Arc', kind: 'Massage Gun', panel: '#33302B', img: '', was: '$250', now: '$145', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/oro-arc-massage-gun', tagline: 'The full-size percussive massage gun for serious muscle recovery.', defaults: ['The pick for anyone who trains hard and talks about DOMS.', 'Percussive therapy for large muscle groups.', '$145 against a $250 RRP.'] },
//         calmcloud: { name: 'Calm Cloud', kind: 'Neck Massager', panel: '#5C7189', img: '', was: '$250', now: '$145', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/calm-cloud-neck-massager', tagline: 'A wearable neck massager for stiff necks and tight shoulders.', defaults: ['Targets the complaint almost everyone has: the neck.', 'Wearable, hands-free relief on the couch or at the desk.', '$145 against a $250 RRP.'] },
//         comfycloud: { name: 'Comfy Cloud', kind: 'Neck Massager', panel: '#175A48', img: '', was: '$290', now: '$190', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/comfy-cloud-neck-massager', tagline: 'The playful character neck massager from the Disney collaboration.', defaults: ['The one that gets a reaction when unwrapped: the Disney collaboration piece.', 'Neck relief with genuine personality.', '$190 against a $290 RRP.'] },
//         otto: { name: 'OTTO', kind: 'Foot Massager', panel: '#8B7355', img: '', was: '$590', now: '$390', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/otto-foot-massager', tagline: 'A foot massager styled as a timber-legged ottoman, furniture first, massager second.', defaults: ['Lives in the lounge room as furniture between sessions.', 'The end-of-day answer for anyone on their feet all day.', '$390 against a $590 RRP.'] },
//         axo: { name: 'AXO', kind: 'Leg Massager', panel: '#3F5866', img: '', was: '$790', now: '$490', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/axo-leg-massager', tagline: 'A full leg massager covering feet and calves in one session.', defaults: ['Feet and calves in a single session, not just soles.', 'A step up for tired legs, not just tired feet.', '$490 against a $790 RRP.'] },
//         plushmini: { name: 'Plush Mini', kind: 'Massage Pillow', panel: '#6E5641', img: '', was: '$290', now: '$190', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/plush-mini-massage-pillow', tagline: 'A compact massage pillow for the desk chair, couch or car seat.', defaults: ['Wedges behind the lower back or neck wherever they sit most.', 'Compact enough to move room to room, or to the office.', '$190 against a $290 RRP.'] },
//         plushpro: { name: 'Plush Pro', kind: 'Massage Cushion', panel: '#9C9C9A', img: '', was: '$550', now: '$345', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/plush-pro-massage-cushion', tagline: 'The full-size massage cushion that upgrades any chair they already own.', defaults: ['Turns their favourite armchair into the massage chair.', 'Back coverage well beyond a travel-size cushion.', '$345 against a $550 RRP.'] },
//         healios: { name: 'Healios', kind: 'Compression Boots', panel: '#1E3A5F', img: '', was: '$1,090', now: '$690', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/healios-compression-boots', tagline: "Sequential air compression boots for leg recovery, the athlete's gift.", defaults: ['Recovery-studio equipment they can use on the couch.', 'The serious gift for the serious trainer.', '$690 against a $1,090 RRP.'] },
//         healiosplus: { name: 'Healios+', kind: 'Compression Boots', panel: '#141414', img: '', was: '$1,490', now: '$890', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/healios-compression-boot', tagline: 'The flagship compression boots, the biggest recovery statement in the portables range.', defaults: ['The top of the portables range: nothing under the tree beats it.', 'Flagship compression recovery for legs that earn it.', '$890 against a $1,490 RRP.'] }
//       }
//     }
//   };

//   ProductQuiz.prototype.cacheDom = function () {
//     var root = this.root;
//     this.el = {
//       progress: root.querySelector('[data-quiz-progress]'),
//       stageImg: root.querySelector('[data-quiz-stage-img]'),
//       stageBg: root.querySelector('[data-quiz-stage-bg]'),
//       paneInner: root.querySelector('[data-quiz-pane-inner]'),
//       eyebrow: root.querySelector('[data-quiz-eyebrow]'),
//       title: root.querySelector('[data-quiz-title]'),
//       help: root.querySelector('[data-quiz-help]'),
//       options: root.querySelector('[data-quiz-options]'),
//       emailWrap: root.querySelector('[data-quiz-email]'),
//       emailNote: root.querySelector('[data-quiz-email-note]'),
//       error: root.querySelector('[data-quiz-error]'),
//       ok: root.querySelector('[data-quiz-ok]'),
//       backText: root.querySelector('[data-quiz-back-text]'),
//       nav: root.querySelector('[data-quiz-nav]'),
//       prev: root.querySelector('[data-quiz-prev]'),
//       next: root.querySelector('[data-quiz-next]'),
//       quizView: root.querySelector('[data-quiz-view]'),
//       resultsView: root.querySelector('[data-quiz-results]'),
//       resultsHeader: root.querySelector('[data-quiz-results-header]'),
//       resultsGrid: root.querySelector('[data-quiz-results-grid]'),
//       resultsFooter: root.querySelector('[data-quiz-results-footer]'),
//       firstName: root.querySelector('[data-quiz-first-name]'),
//       phone: root.querySelector('[data-quiz-phone]'),
//       email: root.querySelector('[data-quiz-email-input]')
//     };
//   };

//   ProductQuiz.prototype.getQuestions = function () {
//     var cat = this.state.category;
//     return this.config.quizzes[cat] || [];
//   };

//   ProductQuiz.prototype.getMeta = function () {
//     var eng = ENGINE[this.state.category];
//     return eng ? eng.meta : {};
//   };

//   ProductQuiz.prototype.getProducts = function () {
//     return this.config.products[this.state.category] || {};
//   };

//   ProductQuiz.prototype.getStages = function () {
//     return this.config.stages[this.state.category] || [];
//   };

//   ProductQuiz.prototype.stepAnswered = function () {
//     var qs = this.getQuestions();
//     if (this.state.step >= qs.length) return false;
//     var q = qs[this.state.step];
//     var a = this.state.answers[q.id];
//     return Array.isArray(a) ? a.length > 0 : !!a;
//   };

//   ProductQuiz.prototype.pick = function (q, optId) {
//     var answers = Object.assign({}, this.state.answers);
//     if (q.multi) {
//       var cur = Array.isArray(answers[q.id]) ? answers[q.id].slice() : [];
//       answers[q.id] = cur.indexOf(optId) > -1 ? cur.filter(function (x) { return x !== optId; }) : cur.concat(optId);
//     } else {
//       answers[q.id] = optId;
//     }
//     this.state.answers = answers;
//     this.state.err = false;
//     this.render();
//   };

//   ProductQuiz.prototype.advance = function () {
//     var qs = this.getQuestions();
//     if (this.state.step < qs.length && !this.stepAnswered()) {
//       this.state.err = true;
//       this.render();
//       return;
//     }
//     this.state.step = Math.min(this.state.step + 1, qs.length);
//     this.state.err = false;
//     this.render();
//     window.scrollTo(0, 0);
//   };

//   ProductQuiz.prototype.goBack = function () {
//     if (this.state.done) return;
//     if (this.state.step === 0) {
//       this.close();
//       return;
//     }
//     this.state.step -= 1;
//     this.state.err = false;
//     this.render();
//   };

//   ProductQuiz.prototype.computeScores = function () {
//     var eng = ENGINE[this.state.category] || {};
//     var products = this.getProducts();
//     var totals = {};
//     Object.keys(products).forEach(function (id) { totals[id] = 0; });
//     var qs = this.getQuestions();
//     qs.forEach(function (q) {
//       if (q.id === 'budget') return;
//       var ans = this.state.answers[q.id];
//       if (!ans) return;
//       var picks = Array.isArray(ans) ? ans : [ans];
//       picks.forEach(function (opt) {
//         var row = ((eng.scores || {})[q.id] || {})[opt] || {};
//         Object.keys(row).forEach(function (pid) { totals[pid] += row[pid]; });
//       });
//     }, this);
//     var budget = this.state.answers.budget;
//     if (budget && eng.budget) {
//       var mult = eng.budget[budget] || {};
//       Object.keys(totals).forEach(function (pid) { totals[pid] *= mult[pid] != null ? mult[pid] : 1; });
//     }
//     var num = function (s) { return parseFloat(String(s).replace(/[^0-9.]/g, '')) || 0; };
//     var ranked = Object.keys(totals).map(function (id) { return { id: id, score: totals[id] }; })
//       .filter(function (r) { return products[r.id]; })
//       .sort(function (a, b) {
//         var p = products;
//         return b.score - a.score || num((p[a.id] && (p[a.id].now || p[a.id].priceLabel)) || 0) - num((p[b.id] && (p[b.id].now || p[b.id].priceLabel)) || 0);
//       });
//     return { totals: totals, ranked: ranked };
//   };

//   ProductQuiz.prototype.reasonsFor = function (pid) {
//     var products = this.getProducts();
//     var out = [];
//     (products[pid] && products[pid].defaults || []).forEach(function (d) { if (out.length < 3) out.push(d); });
//     return out;
//   };

//   ProductQuiz.prototype.answerLabel = function (q, ans) {
//     if (!ans) return '';
//     var picks = Array.isArray(ans) ? ans : [ans];
//     var labels = picks.map(function (id) {
//       var opt = (q.options || []).find(function (o) { return o.id === id; });
//       return opt ? opt.label : id;
//     });
//     return labels.join(', ');
//   };

//   ProductQuiz.prototype.buildSubmissionBody = function () {
//     var qs = this.getQuestions();
//     var products = this.getProducts();
//     var ranked = this.computeScores().ranked;
//     var meta = this.getMeta();
//     var subject = (this.config.emailSubject || 'Olympia Quiz Submission') + ' — ' + this.state.category;
//     var lines = [subject, ''];

//     if (this.config.adminEmail) {
//       lines.push('Notify: ' + this.config.adminEmail);
//       lines.push('');
//     }

//     lines.push('Quiz type: ' + this.state.category);
//     lines.push('First name: ' + (this.state.firstName || '—'));
//     lines.push('Phone: ' + (this.state.phone || '—'));
//     lines.push('Email: ' + this.state.email);
//     lines.push('');
//     lines.push('--- Answers ---');

//     qs.forEach(function (q) {
//       lines.push(q.title + ': ' + this.answerLabel(q, this.state.answers[q.id]));
//     }, this);

//     lines.push('');
//     lines.push('--- Top recommendations ---');
//     ranked.slice(0, 2).forEach(function (r, idx) {
//       var p = products[r.id];
//       if (p) lines.push((idx + 1) + '. ' + p.name + ' (' + (p.now || p.priceLabel || '') + ')');
//     });

//     lines.push('');
//     lines.push('Submitted: ' + new Date().toISOString());
//     return lines.join('\n');
//   };

//   ProductQuiz.prototype.submitEmail = function () {
//     var self = this;
//     var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((this.state.email || '').trim());
//     if (!ok) {
//       this.state.err = true;
//       this.render();
//       return;
//     }

//     if (this.state.submitting) return;
//     this.state.submitting = true;
//     if (this.el.ok) this.el.ok.classList.add('is-loading');

//     var form = document.getElementById('olympia-quiz-contact-form');
//     if (!form) {
//       this.finishSubmission();
//       return;
//     }

//     var nameField = form.querySelector('[data-quiz-form-name]');
//     var emailField = form.querySelector('[data-quiz-form-email]');
//     var bodyField = form.querySelector('[data-quiz-form-body]');

//     if (nameField) nameField.value = (this.state.firstName || '').trim() || 'Quiz visitor';
//     if (emailField) emailField.value = this.state.email.trim();
//     if (bodyField) bodyField.value = this.buildSubmissionBody();

//     this.sendContactForm(form);
//   };

//   ProductQuiz.prototype.sendContactForm = function (form) {
//     var self = this;
//     var formData = new FormData(form);
//     var action = form.getAttribute('action') || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'contact';
//     action = action.split('#')[0];

//     fetch(action, {
//       method: 'POST',
//       body: formData,
//       credentials: 'include',
//       headers: { Accept: 'text/html,application/xhtml+xml' }
//     }).then(function (res) {
//       return res.text().then(function (html) {
//         if (/class=\"errors\"|error-message|There was an error|Invalid captcha|captcha/i.test(html)) {
//           throw new Error('Contact validation failed');
//         }
//         if (res.ok || res.status === 302 || res.status === 303 || /contact[_-]?posted|form-success|Thank you/i.test(html)) {
//           self.finishSubmission();
//           return;
//         }
//         throw new Error('Contact form failed');
//       });
//     }).catch(function () {
//       self.submitContactViaIframe(form);
//     });
//   };

//   ProductQuiz.prototype.submitContactViaIframe = function (form) {
//     var self = this;
//     var iframeName = 'olympia-quiz-contact-iframe';
//     var iframe = document.getElementById(iframeName);

//     if (!iframe) {
//       iframe = document.createElement('iframe');
//       iframe.id = iframeName;
//       iframe.name = iframeName;
//       iframe.title = 'Quiz submission';
//       iframe.setAttribute('aria-hidden', 'true');
//       iframe.tabIndex = -1;
//       iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;clip:rect(0,0,0,0);overflow:hidden';
//       document.body.appendChild(iframe);
//     }

//     var finished = false;
//     function complete(success) {
//       if (finished) return;
//       finished = true;
//       clearTimeout(timer);
//       iframe.onload = null;
//       form.removeAttribute('target');
//       if (success) self.finishSubmission();
//       else self.showSubmitError();
//     }

//     var timer = setTimeout(function () { complete(true); }, 5000);

//     iframe.onload = function () {
//       try {
//         var doc = iframe.contentDocument || iframe.contentWindow.document;
//         var html = doc.body ? doc.body.innerHTML : '';
//         var text = doc.body ? doc.body.innerText : '';
//         var hasError = /class=\"errors\"|error-message|There was an error|Invalid captcha|captcha/i.test(html + text);
//         var hasSuccess = /contact[_-]?posted|form-success|Thank you|Thanks for contacting/i.test(html + text);
//         complete(hasSuccess || !hasError);
//       } catch (err) {
//         complete(true);
//       }
//     };

//     form.setAttribute('target', iframeName);
//     form.submit();
//   };

//   ProductQuiz.prototype.showSubmitError = function () {
//     this.state.submitting = false;
//     this.state.err = true;
//     if (this.el.ok) this.el.ok.classList.remove('is-loading');
//     if (this.el.error) {
//       this.el.error.hidden = false;
//       this.el.error.textContent = 'Could not send your results. Please try again or contact us directly.';
//     }
//   };

//   ProductQuiz.prototype.finishSubmission = function () {
//     this.state.submitting = false;
//     this.state.done = true;
//     this.state.err = false;
//     if (this.el.ok) this.el.ok.classList.remove('is-loading');
//     this.render();
//     window.scrollTo(0, 0);
//   };

//   ProductQuiz.prototype.open = function (category) {
//     this.state = { category: category, step: 0, answers: {}, email: '', firstName: '', phone: '', done: false, err: false };
//     this.root.classList.add('is-active');
//     this.root.classList.remove('is-results-active');
//     var intro = document.querySelector('.shopping-quiz-section');
//     if (intro) intro.classList.add('is-quiz-hidden');
//     this.render();
//     window.scrollTo(0, 0);
//   };

//   ProductQuiz.prototype.close = function () {
//     this.root.classList.remove('is-active', 'is-results-active');
//     var intro = document.querySelector('.shopping-quiz-section');
//     if (intro) intro.classList.remove('is-quiz-hidden');
//     this.state = { category: null, step: 0, answers: {}, email: '', firstName: '', phone: '', done: false, err: false };
//   };

//   ProductQuiz.prototype.restart = function () {
//     this.close();
//     window.scrollTo(0, 0);
//   };

//   ProductQuiz.prototype.renderProgress = function (total, current) {
//     if (!this.el.progress) return;
//     this.el.progress.innerHTML = '';
//     this.el.progress.style.display = 'flex';
//     for (var i = 0; i <= total; i++) {
//       var seg = document.createElement('div');
//       seg.className = 'product-quiz-progress-seg';
//       if (i < current) seg.classList.add('is-complete');
//       if (i === current) seg.classList.add('is-current');
//       this.el.progress.appendChild(seg);
//     }
//   };

//   ProductQuiz.prototype.setStageImage = function (url) {
//     if (this.el.stageImg) {
//       if (url) {
//         this.el.stageImg.src = url;
//         this.el.stageImg.hidden = false;
//       } else {
//         this.el.stageImg.removeAttribute('src');
//         this.el.stageImg.hidden = true;
//       }
//     }
//     if (this.el.stageBg) {
//       this.el.stageBg.style.backgroundImage = url ? "url('" + url.replace(/'/g, '%27') + "')" : '';
//     }
//   };

//   ProductQuiz.prototype.renderOptions = function (q, cur) {
//     if (!this.el.options) return;
//     var self = this;
//     this.el.options.innerHTML = '';
//     (q.options || []).forEach(function (o, n) {
//       var sel = Array.isArray(cur) ? cur.indexOf(o.id) > -1 : cur === o.id;
//       var btn = document.createElement('button');
//       btn.type = 'button';
//       btn.className = 'product-quiz-option' + (sel ? ' is-selected' : '');
//       btn.innerHTML = '<span class="product-quiz-option-key">' + KEYS[n] + '</span><span><span class="product-quiz-option-label">' + o.label + '</span>' + (o.sub ? '<span class="product-quiz-option-sub">' + o.sub + '</span>' : '') + '</span>';
//       btn.addEventListener('click', function () { self.pick(q, o.id); });
//       self.el.options.appendChild(btn);
//     });
//   };

//   ProductQuiz.prototype.renderResults = function () {
//     var meta = this.getMeta();
//     var products = this.getProducts();
//     var ranked = this.computeScores().ranked;
//     var self = this;

//     this.root.classList.add('is-results-active');
//     if (this.el.quizView) this.el.quizView.hidden = true;
//     if (this.el.resultsView) this.el.resultsView.hidden = false;

//     var title = meta.giftTitle
//       ? (this.state.firstName ? this.state.firstName + ', gift sorted.' : 'Gift sorted.')
//       : (this.state.firstName ? this.state.firstName + ', meet' : 'Meet') + ' ' + meta.noun;

//     if (this.el.resultsHeader) {
//       this.el.resultsHeader.innerHTML =
//         '<div class="product-quiz-sent-badge"><span></span>' + meta.sentLabel + ' ' + this.escape(this.state.email) + '</div>' +
//         '<h2 class="product-quiz-results-title">' + this.escape(title) + '</h2>' +
//         '<p class="product-quiz-results-sub">' + this.escape(meta.rSub) + '</p>';
//     }

//     if (this.el.resultsGrid) {
//       this.el.resultsGrid.innerHTML = '';
//       [0, 1].forEach(function (rank) {
//         var pid = ranked[rank] && ranked[rank].id;
//         if (!pid || !products[pid]) return;
//         var c = products[pid];
//         var card = document.createElement('article');
//         card.className = 'product-quiz-result-card';
//         card.style.animationDelay = (rank * 0.08) + 's';
//         var why = self.reasonsFor(pid).map(function (w) { return '<div class="product-quiz-result-why-item">' + self.escape(w) + '</div>'; }).join('');
//         card.innerHTML =
//           '<div class="product-quiz-result-image"' + (c.img ? ' style="background-image:url(\'' + c.img + '\');background-position:' + (c.imgPos || 'center') + ';"' : '') + '>' +
//           '<div class="product-quiz-result-tag ' + (rank === 0 ? 'is-primary' : 'is-secondary') + '">' + (rank === 0 ? meta.tag0 : meta.tag1) + '</div></div>' +
//           '<div class="product-quiz-result-body" style="background-color:' + (c.panel || '#333') + ';">' +
//           '<div class="product-quiz-result-top">' +
//           (c.logoImg ? '<img class="product-quiz-result-logo" src="' + c.logoImg + '" alt="' + self.escape(c.name) + '" style="height:' + (c.logoH || '20px') + '">' :
//             '<div><h3 class="product-quiz-result-name">' + self.escape(c.name) + '</h3>' + (c.kind ? '<div class="product-quiz-result-kind">' + self.escape(c.kind) + '</div>' : '') + '</div>') +
//           '<div class="product-quiz-result-price-wrap">' +
//           (c.was ? '<span class="product-quiz-result-was">' + self.escape(c.was) + '</span>' : '') +
//           '<span class="product-quiz-result-price">' + self.escape(c.now || c.priceLabel) + '</span>' +
//           '<div class="product-quiz-result-price-sub">' + self.escape(c.weekly ? 'or ' + c.weekly + ' interest free' : (c.priceSub || '')) + '</div></div></div>' +
//           '<p class="product-quiz-result-tagline">' + self.escape(c.tagline) + '</p>' +
//           '<div class="product-quiz-result-why"><div class="product-quiz-result-why-title">Why it fits</div>' + why + '</div>' +
//           '<div class="product-quiz-result-actions">' +
//           '<a class="product-quiz-result-btn-primary" href="' + c.url + '">View ' + self.escape(c.name) + '</a>' +
//           '<a class="product-quiz-result-btn-secondary" href="#">' + self.escape(meta.cta2) + '</a></div></div>';
//         self.el.resultsGrid.appendChild(card);
//       });
//     }

//     if (this.el.resultsFooter) {
//       this.el.resultsFooter.innerHTML =
//         '<div class="product-quiz-assure">' + (meta.assure || []).map(function (a) { return '<span>' + self.escape(a) + '</span>'; }).join('') + '</div>' +
//         '<button type="button" class="product-quiz-restart" data-quiz-restart>' + this.escape(meta.restartLabel) + '</button>';
//       this.el.resultsFooter.querySelector('[data-quiz-restart]').addEventListener('click', function () { self.restart(); });
//     }
//   };

//   ProductQuiz.prototype.escape = function (s) {
//     return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
//   };

//   ProductQuiz.prototype.render = function () {
//     if (this.state.done) {
//       this.renderResults();
//       return;
//     }

//     this.root.classList.remove('is-results-active');
//     if (this.el.quizView) this.el.quizView.hidden = false;
//     if (this.el.resultsView) this.el.resultsView.hidden = true;

//     var qs = this.getQuestions();
//     var meta = this.getMeta();
//     var stages = this.getStages();
//     var i = this.state.step;
//     var isEmail = i >= qs.length;
//     var q = isEmail ? null : qs[i];

//     this.renderProgress(qs.length, i);

//     var stageUrl = '';
//     if (isEmail) {
//       if (stages.length) stageUrl = stages[stages.length - 1];
//     } else {
//       if (q && q.stageImage) stageUrl = q.stageImage;
//       if (!stageUrl && stages.length) stageUrl = stages[Math.min(i, stages.length - 1)] || stages[stages.length - 1];
//     }
//     this.setStageImage(stageUrl);

//     if (this.el.paneInner) {
//       this.el.paneInner.style.animation = 'none';
//       void this.el.paneInner.offsetWidth;
//       this.el.paneInner.style.animation = '';
//     }

//     if (this.el.eyebrow) this.el.eyebrow.textContent = isEmail ? '' : 'Question ' + (i + 1) + ' of ' + qs.length;
//     if (this.el.title) this.el.title.textContent = isEmail ? meta.emailTitle : (q ? q.title : '');
//     if (this.el.help) {
//       this.el.help.textContent = q && q.help ? q.help : '';
//       this.el.help.hidden = isEmail;
//     }

//     if (this.el.options) {
//       if (isEmail) {
//         this.el.options.innerHTML = '';
//         this.el.options.hidden = true;
//         this.el.options.classList.add('is-hidden');
//       } else {
//         this.el.options.hidden = false;
//         this.el.options.classList.remove('is-hidden');
//       }
//     }
//     if (this.el.emailWrap) this.el.emailWrap.hidden = !isEmail;
//     if (this.el.nav) this.el.nav.hidden = isEmail;
//     if (this.el.backText) this.el.backText.hidden = !isEmail;

//     if (!isEmail && q) this.renderOptions(q, this.state.answers[q.id]);

//     if (isEmail) {
//       if (this.el.emailNote) this.el.emailNote.textContent = meta.emailNote;
//       if (this.el.firstName) this.el.firstName.value = this.state.firstName;
//       if (this.el.phone) this.el.phone.value = this.state.phone;
//       if (this.el.email) this.el.email.value = this.state.email;
//     }

//     if (this.el.error) {
//       this.el.error.hidden = !this.state.err;
//       this.el.error.textContent = this.state.err ? (isEmail ? meta.errEmail : meta.errSelect) : '';
//     }

//     if (this.el.ok) this.el.ok.textContent = isEmail ? meta.okEmail : 'OK';
//     if (this.el.next) this.el.next.disabled = !this.stepAnswered();
//   };

//   ProductQuiz.prototype.bindEvents = function () {
//     var self = this;
//     if (this.el.ok) this.el.ok.addEventListener('click', function () {
//       var qs = self.getQuestions();
//       if (self.state.step >= qs.length) self.submitEmail();
//       else self.advance();
//     });
//     if (this.el.prev) this.el.prev.addEventListener('click', function () { self.goBack(); });
//     if (this.el.next) this.el.next.addEventListener('click', function () { if (self.stepAnswered()) self.advance(); });
//     if (this.el.backText) this.el.backText.addEventListener('click', function () { self.goBack(); });
//     if (this.el.firstName) this.el.firstName.addEventListener('input', function (e) { self.state.firstName = e.target.value; });
//     if (this.el.phone) this.el.phone.addEventListener('input', function (e) { self.state.phone = e.target.value; });
//     if (this.el.email) {
//       this.el.email.addEventListener('input', function (e) { self.state.email = e.target.value; self.state.err = false; });
//       this.el.email.addEventListener('keydown', function (e) { if (e.key === 'Enter') self.submitEmail(); });
//     }

//     document.addEventListener('click', function (e) {
//       var trigger = e.target.closest('[data-quiz-open]');
//       if (!trigger) return;
//       e.preventDefault();
//       var key = trigger.getAttribute('data-quiz-open');
//       if (key && window.olympiaQuiz) window.olympiaQuiz.open(key);
//     });

//     document.addEventListener('keydown', function (e) {
//       if (!self.state.category || self.state.done) return;
//       if (document.activeElement && document.activeElement.tagName === 'INPUT') return;
//       var qs = self.getQuestions();
//       if (self.state.step >= qs.length) {
//         if (e.key === 'Enter') self.submitEmail();
//         return;
//       }
//       if (e.key === 'Enter') { self.advance(); return; }
//       if (e.key === 'ArrowDown') { if (self.stepAnswered()) self.advance(); return; }
//       if (e.key === 'ArrowUp') { self.goBack(); return; }
//       var idx = KEYS.indexOf(e.key.toUpperCase());
//       var q = qs[self.state.step];
//       if (idx > -1 && q && q.options[idx]) self.pick(q, q.options[idx].id);
//     });
//   };

//   function initQuiz() {
//     var root = document.getElementById('product-quiz-root');
//     if (!root || window.olympiaQuiz) return;
//     window.olympiaQuiz = new ProductQuiz(root);
//     var cfg = readQuizConfig();
//     if (cfg.designMode && cfg.editorPreview && cfg.editorPreview !== 'none') {
//       var intro = document.querySelector('.shopping-quiz-section');
//       if (intro) intro.classList.add('is-quiz-hidden');
//       window.olympiaQuiz.open(cfg.editorPreview);
//     }
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initQuiz);
//   } else {
//     initQuiz();
//   }
// })();



(function () {
  'use strict';

  var KEYS = 'ABCDEF';

  var ENGINE = {
    chairs: {
      scores: {
        who: { me: { bliss: 1, apollo: 2, davinci: 1, zeus: 1 }, partner: { therapi: 2, davinci: 1, robo: 1, zeus: 1 }, household: { therapi: 2, zeus: 2, robo: 2 }, gift: { therapi: 3, bliss: 1 }, work: { zeus: 2, robo: 2, apollo: 1 } },
        goal: { aches: { therapi: 3, apollo: 2, davinci: 1, zeus: 1 }, sport: { zeus: 3, apollo: 2, robo: 1 }, destress: { bliss: 2, davinci: 2, therapi: 1 }, sleep: { bliss: 3, therapi: 2 }, posture: { apollo: 3, robo: 2, zeus: 1 }, all: { davinci: 2, robo: 2, zeus: 1, therapi: 1 } },
        focus: { neck: { therapi: 1, apollo: 1, bliss: 1 }, back: { apollo: 2, therapi: 1, davinci: 1 }, legs: { zeus: 2, therapi: 1, robo: 1 }, arms: { zeus: 3, robo: 2, davinci: 1 }, full: { robo: 2, davinci: 2, zeus: 1 } },
        intensity: { gentle: { bliss: 2, therapi: 2, robo: 1 }, firm: { therapi: 1, apollo: 1, davinci: 1, zeus: 1 }, deep: { davinci: 3, apollo: 2, zeus: 2 }, varies: { robo: 2, davinci: 1, bliss: 1 } },
        space: { compact: { bliss: 3, davinci: 1 }, living: { therapi: 1, apollo: 1, zeus: 1 }, dedicated: { robo: 2, davinci: 2, zeus: 1 } },
        priority: { power: { davinci: 2, zeus: 2, apollo: 1 }, tech: { robo: 3, davinci: 2, bliss: 1 }, design: { davinci: 3, robo: 2, bliss: 1 }, simple: { therapi: 3, bliss: 1 }, value: { bliss: 3, therapi: 2 } }
      },
      budget: {
        b1: { bliss: 1.35, therapi: 1.1, apollo: 0.75, zeus: 0.85, davinci: 0.5, robo: 0.45 },
        b2: { bliss: 1.20, therapi: 1.25, apollo: 1.15, zeus: 0.9, davinci: 0.75, robo: 0.65 },
        b3: { bliss: 1.25, therapi: 0.85, apollo: 1, zeus: 1.3, davinci: 1.2, robo: 1.15 },
        b4: { bliss: 1.25, therapi: 1.7, apollo: 1, zeus: 1.8, davinci: 1.9, robo: 1.15 },
        b0: { bliss: 1.25, therapi: 0.85, apollo: 1, zeus: 1.3, davinci: 1.2, robo: 1.15 }
      },
      reasons: {},
      meta: {
        giftTitle: false,
        noun: 'your Olympia.',
        cta2: 'Book a Demo',
        tag0: 'Your best match ★',
        tag1: 'A close second',
        sentLabel: 'Results sent to',
        restartLabel: 'Retake the quiz',
        emailTitle: 'Where should we send your match?',
        okEmail: 'See my match',
        errEmail: '⚠ A valid email is needed to send the results.',
        errSelect: '⚠ Please make a selection to continue.',
        emailNote: 'Your personalised recommendation is ready — your top two chairs, why they fit, and current pricing. Enter an email to view and receive the results.',
        rSub: 'Two chairs rose to the top of your answers. Both carry the 60 day feel great guarantee and the 5 year platinum warranty, so the choice between them is about how you want to feel.',
        assure: ['60 day guarantee', '5 year platinum warranty', 'Free delivery']
      }
    },
    saunas: {
      scores: {
        today: { facility: { classic: 2, genesis: 2 }, appointments: { genesis: 1, capsule: 1 }, diy: { capsule: 1, solus: 1 }, nothing: { solus: 2, capsule: 1 } },
        friction: { cost: { genesis: 1, classic: 1 }, consistency: { capsule: 2, solus: 2 }, fades: { genesis: 1, capsule: 1 }, public: { classic: 2, genesis: 2 }, nothing_yet: { solus: 2 } },
        signal: { sore: { genesis: 2, classic: 1 }, wired: { classic: 1, genesis: 1, solus: 1 }, flat: { capsule: 1, solus: 1, genesis: 1 }, skin: { genesis: 2, capsule: 1 }, stress: { classic: 1, genesis: 1 } },
        ritual: { steamritual: { classic: 4 }, immersive: { genesis: 3 }, quickreset: { capsule: 2, solus: 2 }, outdoors: { genesis: 3 } },
        who: { me: { solus: 2, capsule: 2, genesis: 1 }, partner: { genesis: 2, classic: 2 }, household: { classic: 3, genesis: 2 }, gift: { solus: 2, capsule: 2, classic: 1 } },
        space: { corner: { capsule: 2, solus: 2, classic: 1, genesis: 1 }, dedicated: { genesis: 2, classic: 2 }, outdoor: { genesis: 3 }, minimal: { solus: 3, capsule: 2 } }
      },
      budget: {
        b1: { genesis: 0.3, classic: 0.35, capsule: 1.5, solus: 0.6 },
        b2: { genesis: 0.5, classic: 1.6, capsule: 1.45, solus: 1.1 },
        b3: { genesis: 1.5, classic: 1.3, capsule: 0.75, solus: 0.6 },
        b4: { genesis: 1.35, classic: 1.15, capsule: 0.55, solus: 0.5 },
        b0: { genesis: 1, classic: 1, capsule: 1, solus: 1 }
      },
      reasons: {},
      meta: {
        giftTitle: false,
        noun: 'your sanctuary.',
        cta2: 'Book a viewing',
        tag0: 'Your best match ★',
        tag1: 'A close second',
        sentLabel: 'Results sent to',
        restartLabel: 'Retake the quiz',
        emailTitle: 'Where should we send your match?',
        okEmail: 'See my match',
        errEmail: '⚠ A valid email is needed to send the results.',
        errSelect: '⚠ Please make a selection to continue.',
        emailNote: 'Your personalised recommendation is ready — your top two saunas, why they fit, and current pricing. Enter an email to view and receive the results.',
        rSub: 'Two saunas rose to the top of your answers. Both are professionally delivered and installed and carry the 5 year platinum warranty, so the choice between them is about how you want your ritual to feel.',
        assure: ['5 year platinum warranty', 'Professional install', 'Australian support']
      }
    },
    gift: {
      scores: {
        who: { partner: { halo: 1, calmcloud: 1, otto: 1, plushpro: 1 }, parent: { otto: 2, plushpro: 2, comfycloud: 1, plushmini: 1, axo: 1 }, friend: { oropebble: 1, spaluxe: 1, halo: 1, plushmini: 1 }, colleague: { spaluxe: 2, oropebble: 1, plushmini: 1, calmcloud: 1 }, anyone: { halo: 1, healios: 1, comfycloud: 1, spaluxe: 1 } },
        occasion: { bday: { plushmini: 1, halo: 1 }, xmas: { otto: 1, healios: 1, plushpro: 1 }, romance: { halo: 2, calmcloud: 1, spaluxe: 1 }, thanks: { spaluxe: 1, oropebble: 1, plushmini: 1 }, justbc: { spaluxe: 1, comfycloud: 1 } },
        needs: { neckshoulders: { calmcloud: 2, comfycloud: 2, plushmini: 1, plushpro: 1 }, feet: { otto: 3, axo: 2, healios: 1 }, training: { oroarc: 3, healios: 2, healiosplus: 2, oropebble: 1, axo: 1 }, screens: { halo: 3, spaluxe: 2 }, sleep: { halo: 2, spaluxe: 1, comfycloud: 1, calmcloud: 1 }, pamper: { spaluxe: 1, halo: 1, otto: 1, plushpro: 1 } },
        days: { desk: { plushmini: 2, calmcloud: 1, halo: 1, plushpro: 1 }, onfeet: { otto: 2, axo: 2, healios: 1 }, active: { oroarc: 2, healios: 2, healiosplus: 2, oropebble: 1 }, home: { otto: 1, plushpro: 1, comfycloud: 1 }, travel: { oropebble: 2, spaluxe: 1, calmcloud: 1, halo: 1 } },
        style: { practical: { oroarc: 1, plushmini: 1, calmcloud: 1, otto: 1 }, luxe: { halo: 2, healiosplus: 2, plushpro: 1 }, statement: { otto: 2, healiosplus: 3, healios: 1, axo: 1, plushpro: 1 }, compact: { spaluxe: 2, oropebble: 2, plushmini: 1, halo: 1 } }
      },
      budget: {
        b1: { spaluxe: 1.5, oropebble: 1.5, calmcloud: 1.35, oroarc: 1.35, halo: 0.7, comfycloud: 0.7, plushmini: 0.7, plushpro: 0.35, otto: 0.3, axo: 0.25, healios: 0.15, healiosplus: 0.12 },
        b2: { halo: 1.4, comfycloud: 1.4, plushmini: 1.4, calmcloud: 1.1, oroarc: 1.1, spaluxe: 0.9, oropebble: 0.9, plushpro: 0.6, otto: 0.5, axo: 0.4, healios: 0.25, healiosplus: 0.2 },
        b3: { plushpro: 1.4, otto: 1.4, axo: 1.35, halo: 0.6, comfycloud: 0.6, plushmini: 0.6, healios: 0.6, healiosplus: 0.45, calmcloud: 0.5, oroarc: 0.5, spaluxe: 0.4, oropebble: 0.4 },
        b4: { healios: 1.5, healiosplus: 1.5, axo: 0.9, otto: 0.8, plushpro: 0.6, halo: 0.4, comfycloud: 0.4, plushmini: 0.4, calmcloud: 0.35, oroarc: 0.35, spaluxe: 0.3, oropebble: 0.3 },
        b0: { spaluxe: 1, halo: 1, oropebble: 1, oroarc: 1, calmcloud: 1, comfycloud: 1, otto: 1, axo: 1, plushmini: 1, plushpro: 1, healios: 1, healiosplus: 1 }
      },
      reasons: {},
      meta: {
        giftTitle: true,
        noun: 'sorted.',
        cta2: 'See all portables',
        tag0: 'The gift ★',
        tag1: 'The backup plan',
        sentLabel: 'Shortlist sent to',
        restartLabel: 'Find another gift',
        emailTitle: 'Where should we send the gift shortlist?',
        okEmail: 'See the picks',
        errEmail: '⚠ A valid email is needed to send the shortlist.',
        errSelect: '⚠ Please make a selection to continue.',
        emailNote: 'The top two gift picks, with current pricing and links, sent straight to the inbox. It also makes a very effective forwardable hint.',
        rSub: 'Two picks rose to the top of the answers. Both ship free to every Australian postcode with 30 day money back, so the safe move is the confident one.',
        assure: ['Free shipping Australia wide', '30 day money back', '50,000+ happy customers']
      }
    }
  };

  function ProductQuiz(root) {
    this.root = root;
    this.config = mergeConfig(readQuizConfig());
    this.state = { category: null, step: 0, answers: {}, email: '', firstName: '', phone: '', done: false, err: false };
    this.cacheDom();
    this.bindEvents();
  }

  var CDN = 'https://cdn.shopify.com/s/files/1/0751/6425/4488/files/';

  function readQuizConfig() {
    var el = document.getElementById('olympia-quiz-config');
    if (el && el.textContent) {
      try {
        return JSON.parse(el.textContent);
      } catch (err) {
        console.error('Olympia quiz: invalid config JSON', err);
      }
    }
    return window.QuizConfig || {};
  }

  function mergeConfig(cfg) {
    var out = { quizzes: {}, stages: {}, products: {}, meta: cfg.meta || {}, editorPreview: cfg.editorPreview || 'none' };
    ['saunas', 'chairs', 'gift'].forEach(function (k) {
      var fromBlocks = (cfg.quizzes && cfg.quizzes[k] && cfg.quizzes[k].length) ? cfg.quizzes[k] : null;
      out.quizzes[k] = fromBlocks || DEFAULTS.quizzes[k] || [];
      var blockStages = (cfg.stages && cfg.stages[k] && cfg.stages[k].length) ? cfg.stages[k] : [];
      var defaults = DEFAULTS.stages[k] || [];
      out.stages[k] = out.quizzes[k].map(function (q, idx) {
        return (q.stageImage && q.stageImage.length) ? q.stageImage : (blockStages[idx] || defaults[idx] || defaults[defaults.length - 1] || '');
      });
      out.products[k] = Object.assign({}, DEFAULTS.products[k] || {}, (cfg.products && cfg.products[k]) || {});
    });
    out.designMode = cfg.designMode || false;
    out.editorPreview = cfg.editorPreview || 'none';
    out.adminEmail = cfg.adminEmail || '';
    out.emailSubject = cfg.emailSubject || 'Olympia Quiz Submission';
    return out;
  }

  var DEFAULTS = {
    quizzes: {
      chairs: [
        { id: 'who', title: "Who's this chair for?", options: [{ id: 'me', label: 'Just me' }, { id: 'partner', label: 'Me and my partner' }, { id: 'household', label: 'The whole household' }, { id: 'gift', label: 'A gift for someone special' }, { id: 'work', label: 'A workplace or practice' }] },
        { id: 'goal', title: 'What should it do for you, above all?', options: [{ id: 'aches', label: 'Ease everyday aches and pains' }, { id: 'sport', label: 'Recover from sport and training' }, { id: 'destress', label: 'Help me switch off and de-stress' }, { id: 'sleep', label: 'Improve my sleep' }, { id: 'posture', label: 'Undo desk posture and tension' }, { id: 'all', label: 'A bit of everything' }] },
        { id: 'focus', title: 'Where does your body need it most?', help: 'Choose as many as you like', multi: true, options: [{ id: 'neck', label: 'Neck and shoulders' }, { id: 'back', label: 'Lower back' }, { id: 'legs', label: 'Legs and feet' }, { id: 'arms', label: 'Arms and hands' }, { id: 'full', label: 'Head to toe' }] },
        { id: 'intensity', title: 'How strong do you like a massage?', options: [{ id: 'gentle', label: 'Gentle and soothing' }, { id: 'firm', label: 'Firm and balanced' }, { id: 'deep', label: 'Deep and powerful' }, { id: 'varies', label: 'Depends on the day' }] },
        { id: 'space', title: 'Where will it live?', options: [{ id: 'compact', label: 'A compact corner', sub: 'Apartment friendly, tidy footprint' }, { id: 'living', label: 'The living room', sub: 'It should earn its place' }, { id: 'dedicated', label: 'A dedicated wellness space', sub: 'Statement pieces welcome' }] },
        { id: 'priority', title: 'What matters most in the decision?', options: [{ id: 'power', label: 'Massage power' }, { id: 'tech', label: 'The smartest technology' }, { id: 'design', label: 'Design that turns heads' }, { id: 'simple', label: 'Simple for everyone to use' }, { id: 'value', label: 'Value for money' }] },
        { id: 'budget', title: 'What budget do you have in mind?', options: [{ id: 'b1', label: '$$', sub: 'Quality relief around $5,000' }, { id: 'b2', label: '$$$', sub: 'Room to move, $7,000 to $9,000' }, { id: 'b3', label: '$$$$', sub: 'All in, $10,000 and beyond' }, { id: 'b0', label: 'Not sure yet', sub: 'Show the best match regardless' }] }
      ],
      saunas: [
        { id: 'today', title: 'How do you recover right now?', options: [{ id: 'facility', label: 'Sauna or ice bath sessions somewhere else', sub: 'A gym, bathhouse or recovery studio' }, { id: 'appointments', label: 'Massage, physio or spa appointments' }, { id: 'diy', label: 'Hot showers, stretching, winging it' }, { id: 'nothing', label: "There's no real routine", sub: "That's kind of the problem" }] },
        { id: 'friction', title: "What's not working about that?", options: [{ id: 'cost', label: 'The costs never stop', sub: 'Memberships, sessions, bookings' }, { id: 'consistency', label: 'Staying consistent', sub: 'Life keeps getting in the way' }, { id: 'fades', label: 'It helps, but it never lasts' }, { id: 'public', label: 'Sharing a sauna with strangers', sub: 'Not exactly relaxing' }, { id: 'nothing_yet', label: "There's nothing in place to fix yet" }] },
        { id: 'signal', title: 'Where is it showing up for you?', help: 'Choose as many as you like', multi: true, options: [{ id: 'sore', label: 'Tight and sore after training' }, { id: 'wired', label: 'Wired at night, hard to switch off' }, { id: 'flat', label: 'Run down, low on energy' }, { id: 'skin', label: 'Skin, circulation, puffiness' }, { id: 'stress', label: 'Carrying stress everywhere' }] },
        { id: 'stakes', title: 'And if nothing changes this year?', options: [{ id: 'spend', label: 'More memberships and appointments to pay for' }, { id: 'nights', label: 'More flat mornings and restless nights' }, { id: 'slipping', label: 'Recovery keeps sliding down the list' }, { id: 'browsing', label: 'Honestly, just browsing for now' }] },
        { id: 'ritual', title: "Picture the perfect end to your day. What's happening?", options: [{ id: 'steamritual', label: 'Deep heat, rolling steam, a proper sweat', sub: 'Then the cold shower' }, { id: 'immersive', label: 'Warm light, music playing, thirty unhurried minutes' }, { id: 'quickreset', label: 'Twenty minutes of heat, then back to life' }, { id: 'outdoors', label: 'Heat therapy on the deck as the sun goes down' }] },
        { id: 'who', title: 'Who else will be stealing sessions?', options: [{ id: 'me', label: "No one. This one's mine" }, { id: 'partner', label: 'My partner, guaranteed' }, { id: 'household', label: 'The whole household will line up' }, { id: 'gift', label: "It's a gift for someone special" }] },
        { id: 'space', title: 'Where do you see it living?', options: [{ id: 'corner', label: 'A spare corner indoors' }, { id: 'dedicated', label: 'A dedicated spot indoors' }, { id: 'outdoor', label: 'Outdoors, deck or garden' }, { id: 'minimal', label: 'As little space as possible' }] },
        { id: 'budget', title: 'If the right sauna ended that cycle, what were you prepared to invest?', options: [{ id: 'b1', label: '$', sub: 'Under $1,500' }, { id: 'b2', label: '$$', sub: '$1,500 to $3,500' }, { id: 'b3', label: '$$$', sub: '$3,500 to $6,000' }, { id: 'b4', label: '$$$$', sub: '$6,000 and beyond' }, { id: 'b0', label: 'Not sure yet', sub: 'Show the match first' }] }
      ],
      gift: [
        { id: 'who', title: "Who's the gift for?", options: [{ id: 'partner', label: 'My partner' }, { id: 'parent', label: 'Mum, Dad or a grandparent' }, { id: 'friend', label: 'A friend or sibling' }, { id: 'colleague', label: 'A colleague or client' }, { id: 'anyone', label: 'The person who has everything' }] },
        { id: 'occasion', title: "What's the occasion?", options: [{ id: 'bday', label: 'Birthday' }, { id: 'xmas', label: 'Christmas' }, { id: 'romance', label: "Anniversary or Valentine's" }, { id: 'thanks', label: 'Thank you or congratulations' }, { id: 'justbc', label: 'Just because' }] },
        { id: 'needs', title: 'What do they mention most?', help: 'Choose as many as you like', multi: true, options: [{ id: 'neckshoulders', label: 'A stiff neck and tight shoulders' }, { id: 'feet', label: 'Sore feet and legs by evening' }, { id: 'training', label: 'Muscle soreness from the gym or sport' }, { id: 'screens', label: 'Tired eyes and too much screen time' }, { id: 'sleep', label: 'Trouble winding down at night' }, { id: 'pamper', label: 'Nothing specific, they love being pampered' }] },
        { id: 'days', title: 'Where do their days mostly happen?', options: [{ id: 'desk', label: 'At a desk' }, { id: 'onfeet', label: 'On their feet' }, { id: 'active', label: 'Training or playing sport' }, { id: 'home', label: 'Around the home' }, { id: 'travel', label: 'On the road or travelling' }] },
        { id: 'style', title: 'What kind of gift lands best with them?', options: [{ id: 'practical', label: 'Practical, something used daily' }, { id: 'luxe', label: "A little luxury they'd never buy themselves" }, { id: 'statement', label: 'A statement under the wrapping paper' }, { id: 'compact', label: 'Small, neat, easy to wrap or post' }] },
        { id: 'budget', title: "What's the gift budget?", options: [{ id: 'b1', label: '$', sub: 'Under $150' }, { id: 'b2', label: '$$', sub: '$150 to $300' }, { id: 'b3', label: '$$$', sub: '$300 to $600' }, { id: 'b4', label: '$$$$', sub: '$600 and beyond' }, { id: 'b0', label: 'Flexible', sub: 'For the right gift' }] }
      ]
    },
    stages: {
      saunas: [
        CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
        CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
        CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
        CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
        CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
        CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
        CDN + 'Product_Categories_Top_Section_-3.jpg?v=1784618119',
        CDN + 'uploads_CTA_Images___jpg.jpg?v=1784618120'
      ],
      chairs: [
        CDN + 'Product_Categories_Top_Section.jpg?v=1784618120',
        CDN + 'Therapi_-_V7.3.jpg?v=1784618120',
        CDN + 'Product_Categories_Top_Section.jpg?v=1784618120',
        CDN + 'Product_Categories_Top_Section.jpg?v=1784618120',
        CDN + 'Product_Categories_Top_Section.jpg?v=1784618120',
        CDN + 'Product_Categories_Top_Section.jpg?v=1784618120',
        CDN + 'uploads_CTA_Images___jpg.jpg?v=1784618120'
      ],
      gift: [
        CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120',
        CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120',
        CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120',
        CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120',
        CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120',
        CDN + 'Product_Categories_Top_Section_-2.jpg?v=1784618120'
      ]
    },
    products: {
      chairs: {
        bliss: { name: 'Bliss XO', panel: '#5C7189', img: '', was: '$9,900', now: '$4,900', weekly: '$34/wk', url: 'https://olympia.au/products/bliss-xo-massage-chair', tagline: "Where modern tech meets infinite comfort. Compact, stylish, and the range's best seller.", defaults: ['4D quad rollers on a flexible SL track, from neck to hamstrings.', 'Space-saving footprint that suits apartments and smaller rooms.', 'Dedicated sleep programs, voice control and zero gravity recline.'] },
        therapi: { name: 'Therapi +', panel: '#175A48', img: '', was: '$13,900', now: '$6,900', weekly: '$48/wk', url: 'https://olympia.au/products/therapi-massage-chair', tagline: 'Heal, soothe and restore. The therapeutic all-rounder the whole household fights over.', defaults: ['Ergonomic stretching and percussion therapy for everyday aches.', 'Heated seat, voice control and built-in speakers, all simple to drive.', "The range's proven family favourite, loved across every age."] },
        apollo: { name: 'Apollo X', panel: '#9C9C9A', img: '', was: '$18,900', now: '$8,900', weekly: '$62/wk', url: 'https://olympia.au/products/apollo-x-massage-chair', tagline: 'Health enhancement built into your lifestyle. Deep tissue strength for people who push hard.', defaults: ['Serious deep tissue power with a heated seat for desk-tight backs.', 'Postural stretching across eight apex points to undo the workday.', '4D quad rollers with weightless zero gravity recline.'] },
        zeus: { name: 'Zeus Athletica', panel: '#A99C8B', img: '', was: '$21,900', now: '$10,900', weekly: '$76/wk', url: 'https://olympia.au/products/zeus-athletica-massage-chair', tagline: 'Unrivalled in features, unmatched in luxury. Built for performance and recovery.', defaults: ['Mechanical deep-tissue arm rollers, elbow to palm. A range first.', 'Dual system rollers and leg stretching tuned for active recovery.', 'SmartGuard motion sensing keeps small children and pets safe.'] },
        davinci: { name: 'DaVinci', panel: '#1E3A5F', img: '', was: '$23,900', now: '$11,900', weekly: '$83/wk', url: 'https://olympia.au/products/davinci-massage-chair', tagline: 'Natural healing meets scientific innovation, in a body designed by ItalDesign.', defaults: ['Sculpted by ItalDesign, the studio behind legendary automotive icons.', 'AI Health Scanner reads body composition and fatigue before each session.', 'High-torque quad rollers with music-synchronised massage programs.'] },
        robo: { name: 'ROBO', panel: '#141414', img: '', was: '$27,900', now: '$13,900', weekly: '$96/wk', url: 'https://olympia.au/products/robo-massage-chair', tagline: 'The flagship. Japanese craftsmanship, robotic precision and timeless design.', defaults: ['Robotic hand and leg massagers with patented dual-action rollers.', 'Facial recognition remembers up to eight users and their settings.', 'Full flat-lay position for spinal decompression and deep recovery.'] }
      },
      saunas: {
        genesis: { name: 'Genesis', kind: 'Infrared Sauna', panel: '#33302B', img: '', priceLabel: 'From $4,900', priceSub: '2, 3 or 4 person', url: 'https://www.olympiasaunas.com.au/products/olympia-genesis', tagline: 'The latest in infrared therapy. A full-spectrum sanctuary with smart controls, therapeutic lighting and integrated audio.', defaults: ['Full-spectrum infrared: near, mid and far wavelengths in one cabin.', '8 low-EMF carbon heaters plus 2 full-spectrum heaters for even, deep warmth.', 'Plugs into a standard 10A socket. No electrician required.'] },
        classic: { name: 'Classic', kind: 'Steam Sauna', panel: '#6E5641', img: '', priceLabel: 'From $3,900', priceSub: '1 to 4 person', url: 'https://www.olympiasaunas.com.au/products/olympia-classic', tagline: 'The traditional sauna experience. Rolling steam, deep enveloping heat and a Harvia heater at the centre of the ritual.', defaults: ['Authentic high heat and humidity, the sauna as it has been practised for generations.', 'A reliable Harvia heater and premium Canadian Hemlock timber.', 'The pick for shared, social, spa-style sessions.'] },
        capsule: { name: 'Capsule', kind: 'Sauna Bath', panel: '#8B7355', img: '', priceLabel: '$2,900', priceSub: 'Single seat capsule', url: 'https://www.olympiasaunas.com.au/products/olympia-capsule', tagline: 'A compact half-body infrared capsule. The enclosed sauna feeling without giving up a room.', defaults: ['Enclosed seating concentrates infrared warmth around the body.', 'A space-saving footprint that fits where a cabin never could.', 'Simple to use for an effective daily infrared session.'] },
        solus: { name: 'Solus', kind: 'Infrared Therapy Chair', panel: '#3F5866', img: '', priceLabel: '$990', priceSub: '475mm wide · 28kg', url: 'https://www.olympiasaunas.com.au/products/solus', tagline: 'A personal infrared wellness chair. Restorative heat in the lightest, most flexible form in the range.', defaults: ['Infrared heating through the base and back in an ergonomic seated design.', 'Ultra-compact and lightweight enough to move room to room.', 'The most accessible way into daily infrared therapy.'] }
      },
      gift: {
        spaluxe: { name: 'Spa Luxe', kind: 'Head Massager', panel: '#7A6A57', img: '', was: '$150', now: '$95', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/spa-luxe-head-massager', tagline: 'A handheld scalp and head massager for instant, anywhere relaxation.', defaults: ['The most giftable price point in the range at $95.', 'Small enough to wrap, post, and use anywhere.', 'A crowd-safe pick: no sizing, no setup, instant effect.'] },
        halo: { name: 'HALO+', kind: 'Eye Massager', panel: '#4A4E58', img: '', was: '$290', now: '$190', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/halo-eye-massager', tagline: 'A wearable eye massager built for screen-tired eyes and wind-down routines.', defaults: ['Made for the person who ends every day in front of a screen.', 'A pamper-level gift that still gets daily use.', '$190 against a $290 RRP.'] },
        oropebble: { name: 'ORO Pebble', kind: 'Massage Gun', panel: '#5F5F5B', img: '', was: '$150', now: '$95', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/oro-pebble-massage-gun', tagline: 'A palm-sized percussive massage gun that travels anywhere.', defaults: ["Pocketable percussive relief at the range's entry price.", 'Fits a gym bag, carry-on or desk drawer.', '$95 against a $150 RRP.'] },
        oroarc: { name: 'ORO Arc', kind: 'Massage Gun', panel: '#33302B', img: '', was: '$250', now: '$145', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/oro-arc-massage-gun', tagline: 'The full-size percussive massage gun for serious muscle recovery.', defaults: ['The pick for anyone who trains hard and talks about DOMS.', 'Percussive therapy for large muscle groups.', '$145 against a $250 RRP.'] },
        calmcloud: { name: 'Calm Cloud', kind: 'Neck Massager', panel: '#5C7189', img: '', was: '$250', now: '$145', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/calm-cloud-neck-massager', tagline: 'A wearable neck massager for stiff necks and tight shoulders.', defaults: ['Targets the complaint almost everyone has: the neck.', 'Wearable, hands-free relief on the couch or at the desk.', '$145 against a $250 RRP.'] },
        comfycloud: { name: 'Comfy Cloud', kind: 'Neck Massager', panel: '#175A48', img: '', was: '$290', now: '$190', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/comfy-cloud-neck-massager', tagline: 'The playful character neck massager from the Disney collaboration.', defaults: ['The one that gets a reaction when unwrapped: the Disney collaboration piece.', 'Neck relief with genuine personality.', '$190 against a $290 RRP.'] },
        otto: { name: 'OTTO', kind: 'Foot Massager', panel: '#8B7355', img: '', was: '$590', now: '$390', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/otto-foot-massager', tagline: 'A foot massager styled as a timber-legged ottoman, furniture first, massager second.', defaults: ['Lives in the lounge room as furniture between sessions.', 'The end-of-day answer for anyone on their feet all day.', '$390 against a $590 RRP.'] },
        axo: { name: 'AXO', kind: 'Leg Massager', panel: '#3F5866', img: '', was: '$790', now: '$490', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/axo-leg-massager', tagline: 'A full leg massager covering feet and calves in one session.', defaults: ['Feet and calves in a single session, not just soles.', 'A step up for tired legs, not just tired feet.', '$490 against a $790 RRP.'] },
        plushmini: { name: 'Plush Mini', kind: 'Massage Pillow', panel: '#6E5641', img: '', was: '$290', now: '$190', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/plush-mini-massage-pillow', tagline: 'A compact massage pillow for the desk chair, couch or car seat.', defaults: ['Wedges behind the lower back or neck wherever they sit most.', 'Compact enough to move room to room, or to the office.', '$190 against a $290 RRP.'] },
        plushpro: { name: 'Plush Pro', kind: 'Massage Cushion', panel: '#9C9C9A', img: '', was: '$550', now: '$345', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/plush-pro-massage-cushion', tagline: 'The full-size massage cushion that upgrades any chair they already own.', defaults: ['Turns their favourite armchair into the massage chair.', 'Back coverage well beyond a travel-size cushion.', '$345 against a $550 RRP.'] },
        healios: { name: 'Healios', kind: 'Compression Boots', panel: '#1E3A5F', img: '', was: '$1,090', now: '$690', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/healios-compression-boots', tagline: "Sequential air compression boots for leg recovery, the athlete's gift.", defaults: ['Recovery-studio equipment they can use on the couch.', 'The serious gift for the serious trainer.', '$690 against a $1,090 RRP.'] },
        healiosplus: { name: 'Healios+', kind: 'Compression Boots', panel: '#141414', img: '', was: '$1,490', now: '$890', priceSub: 'Free shipping · 30 day money back', url: 'https://olympia.au/products/healios-compression-boot', tagline: 'The flagship compression boots, the biggest recovery statement in the portables range.', defaults: ['The top of the portables range: nothing under the tree beats it.', 'Flagship compression recovery for legs that earn it.', '$890 against a $1,490 RRP.'] }
      }
    }
  };

  ProductQuiz.prototype.cacheDom = function () {
    var root = this.root;
    this.el = {
      progress: root.querySelector('[data-quiz-progress]'),
      stageImg: root.querySelector('[data-quiz-stage-img]'),
      stageBg: root.querySelector('[data-quiz-stage-bg]'),
      paneInner: root.querySelector('[data-quiz-pane-inner]'),
      eyebrow: root.querySelector('[data-quiz-eyebrow]'),
      title: root.querySelector('[data-quiz-title]'),
      help: root.querySelector('[data-quiz-help]'),
      options: root.querySelector('[data-quiz-options]'),
      emailWrap: root.querySelector('[data-quiz-email]'),
      emailNote: root.querySelector('[data-quiz-email-note]'),
      error: root.querySelector('[data-quiz-error]'),
      ok: root.querySelector('[data-quiz-ok]'),
      backText: root.querySelector('[data-quiz-back-text]'),
      nav: root.querySelector('[data-quiz-nav]'),
      prev: root.querySelector('[data-quiz-prev]'),
      next: root.querySelector('[data-quiz-next]'),
      quizView: root.querySelector('[data-quiz-view]'),
      resultsView: root.querySelector('[data-quiz-results]'),
      resultsHeader: root.querySelector('[data-quiz-results-header]'),
      resultsGrid: root.querySelector('[data-quiz-results-grid]'),
      resultsFooter: root.querySelector('[data-quiz-results-footer]'),
      skip: root.querySelector('[data-quiz-skip]'),
      firstName: root.querySelector('[data-quiz-first-name]'),
      phone: root.querySelector('[data-quiz-phone]'),
      email: root.querySelector('[data-quiz-email-input]')
    };
  };

  ProductQuiz.prototype.getQuestions = function () {
    var cat = this.state.category;
    return this.config.quizzes[cat] || [];
  };

  ProductQuiz.prototype.getMeta = function () {
    var eng = ENGINE[this.state.category];
    return eng ? eng.meta : {};
  };

  ProductQuiz.prototype.getProducts = function () {
    return this.config.products[this.state.category] || {};
  };

  ProductQuiz.prototype.getStages = function () {
    return this.config.stages[this.state.category] || [];
  };

  ProductQuiz.prototype.stepAnswered = function () {
    var qs = this.getQuestions();
    if (this.state.step >= qs.length) return false;
    var q = qs[this.state.step];
    var a = this.state.answers[q.id];
    return Array.isArray(a) ? a.length > 0 : !!a;
  };

  // ProductQuiz.prototype.pick = function (q, optId) {
  //   var answers = Object.assign({}, this.state.answers);
  //   if (q.multi) {
  //     var cur = Array.isArray(answers[q.id]) ? answers[q.id].slice() : [];
  //     answers[q.id] = cur.indexOf(optId) > -1 ? cur.filter(function (x) { return x !== optId; }) : cur.concat(optId);
  //   } else {
  //     answers[q.id] = optId;
  //   }
  //   this.state.answers = answers;
  //   this.state.err = false;
  //   this.render();
  // };

  ProductQuiz.prototype.pick = function (q, optId) {
    var answers = Object.assign({}, this.state.answers);
    var multiHitLimit = false;
    if (q.multi) {
      var cur = Array.isArray(answers[q.id]) ? answers[q.id].slice() : [];
      var idx = cur.indexOf(optId);
      if (idx > -1) {
        cur = cur.filter(function (x) { return x !== optId; });
      } else {
        cur = cur.concat(optId);
        if (cur.length >= 3) multiHitLimit = true;
      }
      answers[q.id] = cur;
    } else {
      answers[q.id] = optId;
    }
    this.state.answers = answers;
    this.state.err = false;
    this.render();

    // Auto-advance, mobile only (<=991px):
    // - single-select: as soon as an option is tapped
    // - multi-select: once 3 options are selected
    var isMobile = window.matchMedia('(max-width: 991px)').matches;
    var shouldAutoAdvance = (!q.multi) || (q.multi && multiHitLimit);
    if (shouldAutoAdvance && isMobile) {
      var self = this;
      if (this._autoAdvanceTimer) clearTimeout(this._autoAdvanceTimer);
      this._autoAdvanceTimer = setTimeout(function () {
        self._autoAdvanceTimer = null;
        if (self.state.category && !self.state.done) self.advance();
      }, 280);
    }
  };

  ProductQuiz.prototype.advance = function () {
    var qs = this.getQuestions();
    if (this.state.step < qs.length && !this.stepAnswered()) {
      this.state.err = true;
      this.render();
      return;
    }
    this.state.step = Math.min(this.state.step + 1, qs.length);
    this.state.err = false;
    this.render();
    window.scrollTo(0, 0);
  };

  // ProductQuiz.prototype.goBack = function () {
  //   if (this.state.done) return;
  //   if (this.state.step === 0) {
  ProductQuiz.prototype.goBack = function () {
    if (this.state.done) return;
    if (this._autoAdvanceTimer) { clearTimeout(this._autoAdvanceTimer); this._autoAdvanceTimer = null; }
    if (this.state.step === 0) {
      this.close();
      return;
    }
    this.state.step -= 1;
    this.state.err = false;
    this.render();
  };

  
  ProductQuiz.prototype.computeScores = function () {
    var eng = ENGINE[this.state.category] || {};
    var products = this.getProducts();
    var totals = {};
    Object.keys(products).forEach(function (id) { totals[id] = 1; });
    var qs = this.getQuestions();
    // qs.forEach(function (q) {
    //   if (q.id === 'budget') return;
    //   var ans = this.state.answers[q.id];
    //   if (!ans) return;
    //   var picks = Array.isArray(ans) ? ans : [ans];
    //   picks.forEach(function (opt) {
    //     var row = ((eng.scores || {})[q.id] || {})[opt] || {};
    //     Object.keys(row).forEach(function (pid) { totals[pid] += row[pid]; });
    //   });
    // }, this);
    var budget = this.state.answers.budget;
    console.log(budget);
    if(budget == 'b0')
    {
         qs.forEach(function (q) {
            if (q.id == 'intensity')
            {
                if(this.state.answers[q.id] == 'deep')
                {
                 budget= 'b2';
                }
                
            }
            if (q.id == 'signal')
            {
                if(this.state.answers[q.id] == 'sore')
                {
                 budget= 'b2';
                }
                else
                {
                 budget= 'b3';
                }
                
            }
            
              
         }, this);
    }
    if (budget && eng.budget) {
      var mult = eng.budget[budget] || {};
       console.log(mult);
      Object.keys(totals).forEach(function (pid) { totals[pid] *= mult[pid] != null ? mult[pid] : 1; });
    }
    var num = function (s) { return parseFloat(String(s).replace(/[^0-9.]/g, '')) || 0; };
    var ranked = Object.keys(totals).map(function (id) { return { id: id, score: totals[id] }; })
      .filter(function (r) { return products[r.id]; })
      .sort(function (a, b) {
        var p = products;
        return b.score - a.score || num((p[a.id] && (p[a.id].now || p[a.id].priceLabel)) || 0) - num((p[b.id] && (p[b.id].now || p[b.id].priceLabel)) || 0);
      });
    return { totals: totals, ranked: ranked };
  };

  ProductQuiz.prototype.reasonsFor = function (pid) {
    var products = this.getProducts();
    var out = [];
    (products[pid] && products[pid].defaults || []).forEach(function (d) { if (out.length < 3) out.push(d); });
    return out;
  };

  ProductQuiz.prototype.answerLabel = function (q, ans) {
    if (!ans) return '';
    var picks = Array.isArray(ans) ? ans : [ans];
    var labels = picks.map(function (id) {
      var opt = (q.options || []).find(function (o) { return o.id === id; });
      return opt ? opt.label : id;
    });
    return labels.join(', ');
  };

  ProductQuiz.prototype.buildSubmissionBody = function () {
    var qs = this.getQuestions();
    var products = this.getProducts();
    var ranked = this.computeScores().ranked;
    var meta = this.getMeta();
    var subject = (this.config.emailSubject || 'Olympia Quiz Submission') + ' — ' + this.state.category;
    var lines = [subject, ''];

    if (this.config.adminEmail) {
      lines.push('Notify: ' + this.config.adminEmail);
      lines.push('');
    }

    lines.push('Quiz type: ' + this.state.category);
    lines.push('First name: ' + (this.state.firstName || '—'));
    lines.push('Phone: ' + (this.state.phone || '—'));
    lines.push('Email: ' + this.state.email);
    lines.push('');
    lines.push('--- Answers ---');

    qs.forEach(function (q) {
      lines.push(q.title + ': ' + this.answerLabel(q, this.state.answers[q.id]));
    }, this);

    lines.push('');
    lines.push('--- Top recommendations ---');
    ranked.slice(0, 2).forEach(function (r, idx) {
      var p = products[r.id];
      if (p) lines.push((idx + 1) + '. ' + p.name + ' (' + (p.now || p.priceLabel || '') + ')');
    });

    lines.push('');
    lines.push('Submitted: ' + new Date().toISOString());
    return lines.join('\n');
  };

  ProductQuiz.prototype.submitEmail = function () {
    var self = this;
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((this.state.email || '').trim());
    if (!ok) {
      this.state.err = true;
      this.render();
      return;
    }

    if (this.state.submitting) return;
    this.state.submitting = true;
    if (this.el.ok) this.el.ok.classList.add('is-loading');

    var form = document.getElementById('olympia-quiz-contact-form');
    if (!form) {
      this.finishSubmission();
      return;
    }

    var nameField = form.querySelector('[data-quiz-form-name]');
    var emailField = form.querySelector('[data-quiz-form-email]');
    var bodyField = form.querySelector('[data-quiz-form-body]');

    if (nameField) nameField.value = (this.state.firstName || '').trim() || 'Quiz visitor';
    if (emailField) emailField.value = this.state.email.trim();
    if (bodyField) bodyField.value = this.buildSubmissionBody();

    this.sendContactForm(form);
  };

  ProductQuiz.prototype.sendContactForm = function (form) {
    var self = this;
    var formData = new FormData(form);
    var action = form.getAttribute('action') || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'contact';
    action = action.split('#')[0];

    fetch(action, {
      method: 'POST',
      body: formData,
      credentials: 'include',
      headers: { Accept: 'text/html,application/xhtml+xml' }
    }).then(function (res) {
      return res.text().then(function (html) {
        if (/class=\"errors\"|error-message|There was an error|Invalid captcha|captcha/i.test(html)) {
          throw new Error('Contact validation failed');
        }
        if (res.ok || res.status === 302 || res.status === 303 || /contact[_-]?posted|form-success|Thank you/i.test(html)) {
          self.finishSubmission();
          return;
        }
        throw new Error('Contact form failed');
      });
    }).catch(function () {
      self.submitContactViaIframe(form);
    });
  };

  ProductQuiz.prototype.submitContactViaIframe = function (form) {
    var self = this;
    var iframeName = 'olympia-quiz-contact-iframe';
    var iframe = document.getElementById(iframeName);

    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = iframeName;
      iframe.name = iframeName;
      iframe.title = 'Quiz submission';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.tabIndex = -1;
      iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;clip:rect(0,0,0,0);overflow:hidden';
      document.body.appendChild(iframe);
    }

    var finished = false;
    function complete(success) {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      iframe.onload = null;
      form.removeAttribute('target');
      if (success) self.finishSubmission();
      else self.showSubmitError();
    }

    var timer = setTimeout(function () { complete(true); }, 5000);

    iframe.onload = function () {
      try {
        var doc = iframe.contentDocument || iframe.contentWindow.document;
        var html = doc.body ? doc.body.innerHTML : '';
        var text = doc.body ? doc.body.innerText : '';
        var hasError = /class=\"errors\"|error-message|There was an error|Invalid captcha|captcha/i.test(html + text);
        var hasSuccess = /contact[_-]?posted|form-success|Thank you|Thanks for contacting/i.test(html + text);
        complete(hasSuccess || !hasError);
      } catch (err) {
        complete(true);
      }
    };

    form.setAttribute('target', iframeName);
    form.submit();
  };

  ProductQuiz.prototype.showSubmitError = function () {
    this.state.submitting = false;
    this.state.err = true;
    if (this.el.ok) this.el.ok.classList.remove('is-loading');
    if (this.el.error) {
      this.el.error.hidden = false;
      this.el.error.textContent = 'Could not send your results. Please try again or contact us directly.';
    }
  };

  ProductQuiz.prototype.finishSubmission = function () {
    this.state.submitting = false;
    this.state.done = true;
    this.state.err = false;
    if (this.el.ok) this.el.ok.classList.remove('is-loading');
    this.render();
    window.scrollTo(0, 0);
  };

  ProductQuiz.prototype.open = function (category) {
    this.state = { category: category, step: 0, answers: {}, email: '', firstName: '', phone: '', done: false, err: false };
    this.root.classList.add('is-active');
    this.root.classList.remove('is-results-active');
    var intro = document.querySelector('.shopping-quiz-section');
    if (intro) intro.classList.add('is-quiz-hidden');
    this.render();
    window.scrollTo(0, 0);
  };

  ProductQuiz.prototype.close = function () {
    this.root.classList.remove('is-active', 'is-results-active');
    var intro = document.querySelector('.shopping-quiz-section');
    if (intro) intro.classList.remove('is-quiz-hidden');
    this.state = { category: null, step: 0, answers: {}, email: '', firstName: '', phone: '', done: false, err: false };
  };

  ProductQuiz.prototype.restart = function () {
    this.close();
    window.scrollTo(0, 0);
  };

  ProductQuiz.prototype.renderProgress = function (total, current) {
    if (!this.el.progress) return;
    this.el.progress.innerHTML = '';
    this.el.progress.style.display = 'flex';
    for (var i = 0; i <= total; i++) {
      var seg = document.createElement('div');
      seg.className = 'product-quiz-progress-seg';
      if (i < current) seg.classList.add('is-complete');
      if (i === current) seg.classList.add('is-current');
      this.el.progress.appendChild(seg);
    }
  };

  ProductQuiz.prototype.setStageImage = function (url) {
    if (this.el.stageImg) {
      if (url) {
        this.el.stageImg.src = url;
        this.el.stageImg.hidden = false;
      } else {
        this.el.stageImg.removeAttribute('src');
        this.el.stageImg.hidden = true;
      }
    }
    if (this.el.stageBg) {
      this.el.stageBg.style.backgroundImage = url ? "url('" + url.replace(/'/g, '%27') + "')" : '';
    }
  };

  ProductQuiz.prototype.renderOptions = function (q, cur) {
    if (!this.el.options) return;
    var self = this;
    this.el.options.innerHTML = '';
    (q.options || []).forEach(function (o, n) {
      var sel = Array.isArray(cur) ? cur.indexOf(o.id) > -1 : cur === o.id;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-quiz-option' + (sel ? ' is-selected' : '');
      btn.innerHTML = '<span class="product-quiz-option-key">' + KEYS[n] + '</span><span><span class="product-quiz-option-label">' + o.label + '</span>' + (o.sub ? '<span class="product-quiz-option-sub">' + o.sub + '</span>' : '') + '</span>';
      btn.addEventListener('click', function () { self.pick(q, o.id); });
      self.el.options.appendChild(btn);
    });
  };
ProductQuiz.prototype.renderResults = function () {

    var meta = this.getMeta();
    var products = this.getProducts();
    var ranked = this.computeScores().ranked;
    var self = this;

    console.log('Ranked:', ranked);
    console.log('Category:', this.state.category);

    this.root.classList.add('is-results-active');

    if (this.el.quizView) {
        this.el.quizView.hidden = true;
    }

    if (this.el.resultsView) {
        this.el.resultsView.hidden = false;
    }

    /*
     * ----------------------------------------
     * HELPERS
     * ----------------------------------------
     */

    function esc(value) {

        value = value == null ? '' : String(value);

        return value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function imageUrl(url) {

        if (!url) {
            return '';
        }

        url = String(url).trim();

        /*
         * //olympia.au/... -> https://olympia.au/...
         */
        if (url.indexOf('//') === 0) {
            return 'https:' + url;
        }

        return url;
    }

    function productUrl(product) {

        return (
            product.url ||
            product.link ||
            product.href ||
            product.productUrl ||
            '#'
        );
    }

    /*
     * ----------------------------------------
     * PRODUCT IMAGE HELPERS
     * ----------------------------------------
     */

    function productImage(product) {

        return imageUrl(
            product.img ||
            product.mainImage ||
            product.image ||
            product.image1 ||
            ''
        );
    }

    function productImage2(product) {

        return imageUrl(
            product.image2 ||
            product.img2 ||
            product.secondImage ||
            ''
        );
    }

    function productImage3(product) {

        return imageUrl(
            product.image3 ||
            product.img3 ||
            product.thirdImage ||
            ''
        );
    }

    function productImage4(product) {

        return imageUrl(
            product.image4 ||
            product.img4 ||
            product.fourthImage ||
            ''
        );
    }

    /*
     * ----------------------------------------
     * GET ALL PRODUCT IMAGES
     * ----------------------------------------
     *
     * Order:
     *
     * 1 = img
     * 2 = image2
     * 3 = image3
     * 4 = image4
     *
     * Empty images are removed.
     * Duplicate URLs are removed.
     */

    function getProductImages(product) {

        var images = [

            productImage(product),

            productImage2(product),

            productImage3(product),

            productImage4(product)

        ];

        var uniqueImages = [];

        images.forEach(function (src) {

            if (!src) {
                return;
            }

            if (
                uniqueImages.indexOf(src) !== -1
            ) {
                return;
            }

            uniqueImages.push(src);

        });

        return uniqueImages;
    }

    function productDescription(product) {

        return (
            product.tagline ||
            ''
        );
    }

    function productPrice(product) {

        return (
            product.priceLabel ||
            product.price ||
            product.now ||
            ''
        );
    }

    /*
     * ----------------------------------------
     * RESULTS GRID
     * ----------------------------------------
     */

    if (this.el.resultsGrid) {

        this.el.resultsGrid.innerHTML = '';

        if (
            !ranked ||
            !ranked.length
        ) {

            console.warn(
                'No ranked products found.'
            );

            return;
        }

        /*
         * ----------------------------------------
         * MAIN PRODUCT
         * ----------------------------------------
         */

        var mainRank = 0;

        var mainRanked =
            ranked[mainRank];

        if (!mainRanked) {

            console.warn(
                'No main ranked product.'
            );

            return;
        }

        var mainPid =
            mainRanked.id;

        var mainProduct =
            products[mainPid];

        if (!mainProduct) {

            console.warn(
                'Main product not found:',
                mainPid
            );

            return;
        }

        console.log(
            'Main product:',
            mainProduct
        );

        /*
         * ----------------------------------------
         * ALL MAIN PRODUCT IMAGES
         * ----------------------------------------
         */

        var allImages =
            getProductImages(mainProduct);

        console.log(
            'All main product images:',
            allImages
        );

        /*
         * First image is displayed initially.
         */
        var mainImg =
            allImages[0] || '';

        var mainName =
            mainProduct.name ||
            mainProduct.title ||
            mainProduct.productName ||
            'Product';

        var mainKind =
            mainProduct.kind ||
            mainProduct.category ||
            '';

        var mainDescription =
            productDescription(mainProduct);

        var mainPrice =
            productPrice(mainProduct);

        var mainUrl =
            productUrl(mainProduct);

        /*
         * ----------------------------------------
         * WHY ICONS
         * ----------------------------------------
         */

        var whyIcons = [

            '<svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 26px;width:26px;height:26px;display:block;">' +
                '<path d="M12 2.9c1 2.2 2.4 4 3.9 5.8 1.4 1.7 2.6 3.7 2.6 6 0 3.8-2.7 6.4-6.5 6.4s-6.5-2.6-6.5-6.4c0-2.3 1.2-4.3 2.6-6C9.6 6.9 11 5.1 12 2.9zM12 21.1c-1.9 0-3.2-1.2-3.2-3 0-1.7 1.5-3 3.2-4.8 1.7 1.8 3.2 3.1 3.2 4.8 0 1.8-1.3 3-3.2 3z"></path>' +
            '</svg>',

            '<svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 26px;width:26px;height:26px;display:block;">' +
                '<path d="M4.5 20.5v-11h15v11zM4.5 13h15M7.5 9.5V6a1.5 1.5 0 013 0M13.5 9.5V6a1.5 1.5 0 013 0M8 16.5h1.5M14.5 16.5H16"></path>' +
            '</svg>',

            '<svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 26px;width:26px;height:26px;display:block;">' +
                '<path d="M12 3l5.5 6.5h-3L19 14h-3.5l4 5H4.5l4-5H5l4.5-4.5h-3zM12 19v2.5"></path>' +
            '</svg>',

            '<svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 26px;width:26px;height:26px;display:block;">' +
                '<path d="M4.5 9.5h15v10h-15zM4.5 13h15M8 6.5l1.5-3 2 2.5 2-2.5 1.5 3M9.5 16.2h.01M12.5 17h.01M14.8 15.8h.01"></path>' +
            '</svg>'

        ];

        /*
         * ----------------------------------------
         * THUMBNAIL BUILDER
         * ----------------------------------------
         *
         * IMPORTANT:
         *
         * currentImage is the image currently
         * displayed large.
         *
         * Every other available image becomes
         * a thumbnail.
         *
         * Example:
         *
         * Current = image1
         * thumbs  = image2, image3, image4
         *
         * Current = image3
         * thumbs  = image1, image2, image4
         */

        function buildThumbnails(currentImage) {

            var html = '';

            allImages.forEach(function (src) {

                if (!src) {
                    return;
                }

                /*
                 * NEVER show current large image
                 * as thumbnail.
                 */
                if (src === currentImage) {
                    return;
                }

                html +=

                    '<div ' +

                        'data-act="thumb" ' +

                        'data-image="' +
                            esc(src) +
                        '"' +

                        'style="' +
                            'width:74px;' +
                            'height:74px;' +
                            'border-radius:8px;' +
                            'background:#EDEDEA;' +
                            'overflow:hidden;' +
                            'cursor:pointer;' +
                            'box-shadow:0 4px 14px rgba(0,0,0,.18);' +
                            'border:1px solid rgba(255,255,255,.9);' +
                            'flex:0 0 74px;' +
                        '"' +

                    '>' +

                        '<img ' +

                            'src="' +
                                esc(src) +
                            '"' +

                            'alt="' +
                                esc(mainName) +
                            '"' +

                            'style="' +
                                'width:100%;' +
                                'height:100%;' +
                                'display:block;' +
                                'object-fit:cover;' +
                            '"' +

                        '>' +

                    '</div>';

            });

            return html;
        }

        /*
         * ----------------------------------------
         * MAIN IMAGE HTML
         * ----------------------------------------
         */

        var mainImageHtml = '';

        if (mainImg) {

            mainImageHtml =

                '<img ' +

                    'class="oq-main-product-image" ' +

                    'src="' +
                        esc(mainImg) +
                    '"' +

                    'alt="' +
                        esc(mainName) +
                    '"' +

                    'style="' +
                        'position:absolute;' +
                        'inset:0;' +
                        'width:100%;' +
                        'height:100%;' +
                        'object-fit:cover;' +
                        'object-position:' +
                            esc(
                                mainProduct.imgPos ||
                                'center'
                            ) +
                        ';' +
                        'display:block;' +
                    '"' +

                '>';

        } else {

            mainImageHtml =

                '<div style="' +
                    'position:absolute;' +
                    'inset:0;' +
                    'display:flex;' +
                    'align-items:center;' +
                    'justify-content:center;' +
                    'background:#EDEDEA;' +
                    'color:#999;' +
                    'font:400 13px Archivo,sans-serif;' +
                '">' +

                    'No image available' +

                '</div>';
        }

        /*
         * ----------------------------------------
         * MAIN PRODUCT CARD
         * ----------------------------------------
         */

        var card =
            document.createElement('article');

        card.className =
            'product-quiz-result-card';

        card.innerHTML =

            '<div style="' +
                'background:#FDFBF4;' +
            '">' +

                '<div class="oq-fade q-main-result-layout" style="' +
                    'display:grid;' +
                    'grid-template-columns:50% 50%;' +
                    'min-height:720px;' +
                '">' +

                    /*
                     * IMAGE SECTION
                     */
                    '<div class="oq-main-product-image-wrap" style="' +
                        'position:relative;' +
                        'background-color:#EDEDEA;' +
                        'overflow:hidden;' +
                        'min-height:720px;' +
                    '">' +

                        mainImageHtml +

                        /*
                         * THUMBNAIL CONTAINER
                         */
                        '<div ' +
                            'class="oq-thumbnail-container" ' +
                            'style="' +
                                'position:absolute;' +
                                'left:0;' +
                                'right:0;' +
                                'bottom:0;' +
                                'display:flex;' +
                                'justify-content:center;' +
                                'gap:10px;' +
                                'padding:20px;' +
                            '"' +
                        '>' +

                            buildThumbnails(mainImg) +

                        '</div>' +

                    '</div>' +

                    /*
                     * CONTENT SECTION
                     */
                    '<div style="' +
                        'position:relative;' +
                        'display:flex;' +
                        'flex-direction:column;' +
                        'padding:64px clamp(32px,4.5vw,72px) 0;' +
                        'background:#FDFBF4;' +
                    '">' +

                        /*
                         * EMAIL
                         */
                        '<div style="' +
                            'font:400 11.5px Archivo,sans-serif;' +
                            'letter-spacing:.16em;' +
                            'text-transform:uppercase;' +
                            'color:#B0ADA5;' +
                            'margin-bottom:10px;' +
                        '">' +

                            esc(
                                meta.sentLabel ||
                                'Results sent to'
                            ) +

                            ' ' +

                            esc(
                                this.state.email ||
                                ''
                            ) +

                        '</div>' +

                        /*
                         * PERFECT MATCH
                         */
                        '<div style="' +
                            'font:400 11.5px Archivo,sans-serif;' +
                            'letter-spacing:.13em;' +
                            'text-transform:uppercase;' +
                            'color:#8E8B84;' +
                        '">' +

                            'Your perfect match' +

                        '</div>' +

                        /*
                         * PRODUCT NAME
                         */
                        '<a ' +

                            'class="oq-hero-title" ' +

                            'href="' +
                                esc(mainUrl) +
                            '"' +

                            'target="_blank" ' +
                            'rel="noopener" ' +

                            'style="' +
                                'display:block;' +
                                'font:500 clamp(30px,2.9vw,44px)/1.08 Archivo,sans-serif;' +
                                'letter-spacing:-.02em;' +
                                'margin:14px 0 4px;' +
                                'color:#111;' +
                                'text-decoration:none;' +
                            '"' +

                        '>' +

                            esc(mainName) +

                        '</a>' +

                        /*
                         * PRODUCT KIND
                         */
                        (
                            mainKind

                                ? '<div style="' +
                                    'font:400 12px Archivo,sans-serif;' +
                                    'text-transform:uppercase;' +
                                    'letter-spacing:.12em;' +
                                    'color:#8E8B84;' +
                                    'margin-top:4px;' +
                                '">' +

                                    esc(mainKind) +

                                '</div>'

                                : ''
                        ) +

                        /*
                         * DESCRIPTION
                         */
                        '<div style="' +
                            'margin-top:20px;' +
                            'font:400 15.5px Archivo,sans-serif;' +
                            'color:#5F5F5B;' +
                            'line-height:1.65;' +
                            'max-width:52ch;' +
                        '">' +

                            esc(mainDescription) +

                        '</div>' +

                        /*
                         * ----------------------------------------
                         * WHY THIS PRODUCT
                         * ----------------------------------------
                         */

                        '<div style="' +
                            'margin-top:30px;' +
                            'display:flex;' +
                            'flex-direction:column;' +
                        '">' +

                            self.reasonsFor(mainPid)

                                .map(function (w, i) {

                                    return (

                                        '<div style="' +
                                            'display:flex;' +
                                            'gap:16px;' +
                                            'align-items:flex-start;' +
                                            'padding:18px 0;' +
                                            'border-top:1px solid #E7E4DC;' +
                                        '">' +

                                            /*
                                             * ICON
                                             */
                                            whyIcons[
                                                i %
                                                whyIcons.length
                                            ] +

                                            /*
                                             * TEXT
                                             */
                                            '<span style="' +
                                                'font:400 14.5px/1.55 Archivo,sans-serif;' +
                                                'color:#33312D;' +
                                            '">' +

                                                esc(w) +

                                            '</span>' +

                                        '</div>'

                                    );

                                })

                                .join('') +

                        '</div>' +

                        /*
                         * ----------------------------------------
                         * BOTTOM PRODUCT BAR
                         * ----------------------------------------
                         */

                        '<div style="' +
                            'margin-top:auto;' +
                            'margin-left:clamp(-72px,-4.5vw,-32px);' +
                            'margin-right:clamp(-72px,-4.5vw,-32px);' +
                            'border-top:1px solid #E9E4D6;' +
                            'background:#F8F5EB;' +
                            'padding:22px clamp(32px,4.5vw,72px);' +
                            'display:flex;' +
                            'align-items:center;' +
                            'justify-content:space-between;' +
                            'gap:20px;' +
                            'flex-wrap:wrap;' +
                        '">' +

                            '<div>' +

                                '<div style="' +
                                    'font:600 16px Archivo,sans-serif;' +
                                '">' +

                                    esc(mainName) +

                                '</div>' +

                                '<div style="' +
                                    'display:flex;' +
                                    'align-items:baseline;' +
                                    'gap:10px;' +
                                    'margin-top:4px;' +
                                '">' +

                                    '<span style="' +
                                        'font:500 17px Archivo,sans-serif;' +
                                        'color:#C8362A;' +
                                    '">' +

                                        esc(mainPrice) +

                                    '</span>' +

                                '</div>' +

                                '<a ' +

                                    'href="' +
                                        esc(mainUrl) +
                                    '"' +

                                    'target="_blank" ' +
                                    'rel="noopener" ' +

                                    'style="' +
                                        'display:inline-block;' +
                                        'margin-top:7px;' +
                                        'font:400 12.5px Archivo,sans-serif;' +
                                        'color:#5F5F5B;' +
                                        'text-decoration:underline;' +
                                    '"' +

                                '>' +

                                    'See full details' +

                                '</a>' +

                            '</div>' +

                            '<button ' +
    'type="button" ' +
    'data-act="add-to-cart" ' +
    'style="' +
        'border:0;' +
        'background:#111;' +
        'color:#fff;' +
        'font:600 15px Archivo,sans-serif;' +
        'padding:17px 78px;' +
        'border-radius:8px;' +
        'cursor:pointer;' +
    '"' +
'>' +

    'Add to cart' +

'</button>' +

                            '</a>' +

                        '</div>' +

                    '</div>' +

                '</div>' +

            '</div>';

        this.el.resultsGrid.appendChild(card);
/*
 * ----------------------------------------
 * ADD TO CART
 * ----------------------------------------
 */

var addToCartButton =
    card.querySelector('[data-act="add-to-cart"]');

if (addToCartButton) {

    addToCartButton.addEventListener(
        'click',
        function () {

            var variantId =
                mainProduct.variantId;

            if (!variantId) {
                console.warn(
                    'No variant ID found for:',
                    mainPid,
                    mainProduct
                );

                window.location.href = mainUrl;
                return;
            }

            var originalText =
                addToCartButton.textContent;

            addToCartButton.disabled = true;

            addToCartButton.textContent =
                'Adding...';

            fetch('/cart/add.js', {
                method: 'POST',

                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },

                body: JSON.stringify({
                    items: [
                        {
                            id: Number(variantId),
                            quantity: 1
                        }
                    ]
                })
            })

            .then(function (response) {

                if (!response.ok) {
                    return response.json()
                        .then(function (error) {
                            throw error;
                        });
                }

                return response.json();

            })

            .then(function (data) {

                console.log(
                    'Product added to cart:',
                    data
                );

                addToCartButton.textContent =
                    'Added to cart';

                /*
                 * Optional: update Shopify cart drawer
                 * if the theme provides one.
                 */
                document.dispatchEvent(
                    new CustomEvent(
                        'cart:updated',
                        {
                            detail: data
                        }
                    )
                );

                /*
                 * Return button to normal after 2 seconds.
                 */
                setTimeout(function () {

                    addToCartButton.disabled = false;

                    addToCartButton.textContent =
                        originalText;

                }, 2000);

            })

            .catch(function (error) {

                console.error(
                    'Add to cart failed:',
                    error
                );

                addToCartButton.disabled = false;

                addToCartButton.textContent =
                    'Add to cart';

            });

        }
    );

}

        /*
         * ----------------------------------------
         * IMAGE THUMBNAIL EVENTS
         * ----------------------------------------
         *
         * This is the important part.
         *
         * Every time the large image changes:
         *
         * 1. Change large image.
         * 2. Rebuild thumbnails.
         * 3. Remove the new large image from thumbs.
         * 4. Put the previously large image back
         *    into the thumbnails.
         */

        var mainImageElement =
            card.querySelector(
                '.oq-main-product-image'
            );

        var thumbnailContainer =
            card.querySelector(
                '.oq-thumbnail-container'
            );

        /*
         * Function to bind all current thumbnails.
         */
        function bindThumbnails() {

            if (!thumbnailContainer) {
                return;
            }

            thumbnailContainer
                .querySelectorAll(
                    '[data-act="thumb"]'
                )
                .forEach(function (thumb) {

                    thumb.addEventListener(
                        'click',
                        function () {

                            var src =
                                thumb.getAttribute(
                                    'data-image'
                                );

                            if (!src) {
                                return;
                            }

                            /*
                             * Change large image.
                             */
                            if (mainImageElement) {

                                mainImageElement.src =
                                    src;
                            }

                            /*
                             * Rebuild thumbnails.
                             *
                             * The clicked image is now
                             * the large image, therefore
                             * buildThumbnails() excludes it.
                             */
                            if (thumbnailContainer) {

                                thumbnailContainer.innerHTML =
                                    buildThumbnails(
                                        src
                                    );

                                /*
                                 * Bind the newly created
                                 * thumbnails.
                                 */
                                bindThumbnails();
                            }

                        }
                    );

                });
        }

        /*
         * Initial binding.
         */
        bindThumbnails();

        /*
         * ----------------------------------------
         * ALSO WORTH A LOOK
         * ----------------------------------------
         */

        var worthLookHtml =

            '<div style="' +
                'padding:70px clamp(32px,6vw,90px) 40px;' +
            '">' +

                '<div style="' +
                    'font:300 clamp(26px,2.6vw,34px) Archivo,sans-serif;' +
                    'letter-spacing:-.01em;' +
                    'margin-bottom:24px;' +
                '">' +

                    'Also worth a look' +

                '</div>' +

                '<div style="' +
                    'display:flex;' +
                    'gap:24px;' +
                    'overflow-x:auto;' +
                    'padding-bottom:16px;' +
                    'scroll-snap-type:x mandatory;' +
                '">';

        /*
         * ----------------------------------------
         * OTHER RANKED PRODUCTS
         * ----------------------------------------
         */
        var limit = this.state.category === 'chairs' ? 3 : 4;
        ranked
            .slice(1,limit)
            .forEach(function (item) {

                var pid =
                    item &&
                    item.id;

                if (
                    !pid ||
                    !products[pid]
                ) {
                    return;
                }

                var p =
                    products[pid];

                console.log(
                    'Worth looking product:',
                    pid,
                    p
                );

                var pName =
                    p.name ||
                    p.title ||
                    p.productName ||
                    'Product';

                var pDesc =
                    productDescription(p);

                var pPrice =
                    productPrice(p);

                var pUrl =
                    productUrl(p);

                /*
                 * Main image for worth-look product.
                 */
                var pImg =
                    productImage(p);

                console.log(
                    'Product image:',
                    pid,
                    pImg
                );
                var pImg2 =
    productImage2(p);

                worthLookHtml +=

                    '<a ' +

                        'class="oq-alt" ' +

                        'data-act="promote" ' +

                        'data-pid="' +
                            esc(pid) +
                        '"' +

                        'href="' +
                            esc(pUrl) +
                        '"' +

                        'target="_blank" ' +
                        'rel="noopener" ' +

                        'style="' +
                            'cursor:pointer;' +
                            'text-decoration:none;' +
                            'color:inherit;' +
                            'display:flex;' +
                            'flex-direction:column;' +
                            'gap:14px;' +
                            'flex:0 0 300px;' +
                            'scroll-snap-align:start;' +
                        '"' +

                    '>' +

                        /*
 * IMAGE
 * Main image normally.
 * Second image appears on hover.
 */
'<div ' +
    'class="oq-worth-image" ' +
    'style="' +
        'position:relative;' +
        'border-radius:14px;' +
        'overflow:hidden;' +
        'background:#F3F0E7;' +
        'aspect-ratio:1/1.05;' +
    '"' +
'>' +

    /*
     * MAIN IMAGE
     */
    (
        pImg

        ? '<img ' +
            'class="oq-worth-image-main" ' +
            'src="' + esc(pImg) + '" ' +
            'alt="' + esc(pName) + '" ' +
            'style="' +
                'position:absolute;' +
                'inset:0;' +
                'width:100%;' +
                'height:100%;' +
                'object-fit:cover;' +
                'display:block;' +
                'transition:opacity .35s ease;' +
            '"' +
          '>'

        : ''
    ) +

    /*
     * SECOND IMAGE
     */
    (
        pImg2 && pImg2 !== pImg

        ? '<img ' +
            'class="oq-worth-image-hover" ' +
            'src="' + esc(pImg2) + '" ' +
            'alt="' + esc(pName) + '" ' +
            'style="' +
                'position:absolute;' +
                'inset:0;' +
                'width:100%;' +
                'height:100%;' +
                'object-fit:cover;' +
                'display:block;' +
                'opacity:0;' +
                'transition:opacity .35s ease;' +
            '"' +
          '>'

        : ''
    ) +

    /*
     * NO IMAGE
     */
    (
        !pImg

        ? '<div style="' +
            'position:absolute;' +
            'inset:0;' +
            'display:flex;' +
            'align-items:center;' +
            'justify-content:center;' +
            'color:#999;' +
            'font:400 13px Archivo,sans-serif;' +
          '">' +
            'No image available' +
          '</div>'

        : ''
    ) +

'</div>' +


                        /*
                         * NAME
                         */
                        '<div style="' +
                            'font:500 16px Archivo,sans-serif;' +
                            'letter-spacing:-.01em;' +
                        '">' +

                            esc(pName) +

                        '</div>' +

                        /*
                         * DESCRIPTION
                         */
                        '<div style="' +
                            'font:400 15px Archivo,sans-serif;' +
                            'color:#6A6862;' +
                            'line-height:1.45;' +
                            'margin-top:-6px;' +
                        '">' +

                            esc(pDesc) +

                        '</div>' +

                        /*
                         * PRICE
                         */
                        '<div style="' +
                            'display:flex;' +
                            'align-items:baseline;' +
                            'gap:10px;' +
                            'margin-top:-2px;' +
                        '">' +

                            '<span style="' +
                                'font:400 15.5px Archivo,sans-serif;' +
                                'color:#C8362A;' +
                            '">' +

                                esc(pPrice) +

                            '</span>' +

                        '</div>' +

                    '</a>';

            });

        worthLookHtml +=

                '</div>' +

                /*
                 * RETAKE
                 */
                '<div style="' +
                    'margin-top:44px;' +
                    'padding-bottom:50px;' +
                '">' +

                    '<div ' +

                        'data-act="retake" ' +

                        'class="oq-retake" ' +

                        'style="' +
                            'display:inline-block;' +
                            'padding:17px 34px;' +
                            'border-radius:10px;' +
                            'border:1px solid #DED8C9;' +
                            'background:#FDFBF4;' +
                            'font:600 15px Archivo,sans-serif;' +
                            'cursor:pointer;' +
                        '"' +

                    '>' +

                        'Retake the quiz' +

                    '</div>' +

                '</div>' +

            '</div>';

        /*
         * Add worth-look section.
         */
        this.el.resultsGrid.insertAdjacentHTML(
            'beforeend',
            worthLookHtml
        );

        /*
         * ----------------------------------------
         * RETAKE EVENT
         * ----------------------------------------
         */

        var retake =
            this.el.resultsGrid.querySelector(
                '[data-act="retake"]'
            );

        if (retake) {

            retake.addEventListener(
                'click',
                function () {

                    if (
                        typeof self.resetQuiz ===
                        'function'
                    ) {

                        self.resetQuiz();
                    }

                    if (self.el.resultsView) {

                        self.el.resultsView.hidden =
                            true;
                    }

                    if (self.el.quizView) {

                        self.el.quizView.hidden =
                            false;
                    }

                }
            );
        }

        /*
         * ----------------------------------------
         * IMAGE ERROR FALLBACK
         * ----------------------------------------
         */

        this.el.resultsGrid
            .querySelectorAll('img')
            .forEach(function (img) {

                img.addEventListener(
                    'error',
                    function () {

                        console.warn(
                            'Image failed:',
                            img.src
                        );

                        img.style.display =
                            'none';

                    }
                );

            });

    }
};
if (!document.getElementById('oq-worth-hover-style')) {

    var worthStyle =
        document.createElement('style');

    worthStyle.id =
        'oq-worth-hover-style';

    worthStyle.textContent =
        '.oq-alt:hover .oq-worth-image-hover {' +
            'opacity:1 !important;' +
        '}' +

        '.oq-alt:hover .oq-worth-image-main {' +
            'opacity:0;' +
        '}';

    document.head.appendChild(worthStyle);
}

if (!document.getElementById('oq-result-responsive-css')) {

    var style = document.createElement('style');

    style.id = 'oq-result-responsive-css';

    style.textContent = `

        /* =========================================
   MOBILE
   ========================================= */

@media screen and (max-width: 767px) {

    /* IMAGE + CONTENT STACK */
    .oq-main-result-layout {
        display: flex !important;
        flex-direction: column !important;
        width: 100% !important;
        min-height: 0 !important;
        height: auto !important;
    }


    /* =====================================
       IMAGE MUST COME FIRST
       ===================================== */

    .oq-main-product-image-wrap {
        position: relative !important;

        order: 1 !important;

        display: block !important;

        width: 100% !important;

        /*
         * Override desktop 720px height
         */
        height: 100vw !important;
        min-height: 320px !important;
        max-height: 600px !important;

        /*
         * Prevent flex/grid sizing from
         * moving content above it
         */
        flex: 0 0 auto !important;

        box-sizing: border-box !important;

        overflow: hidden !important;
    }


    /* =====================================
       MAIN IMAGE
       ===================================== */

    .oq-main-product-image-wrap .oq-main-product-image {
        position: absolute !important;
        inset: 0 !important;

        width: 100% !important;
        height: 100% !important;

        object-fit: cover !important;

        display: block !important;
    }


    /* =====================================
       THUMBNAILS
       ===================================== */

    .oq-main-product-image-wrap .oq-thumbnail-container {
        position: absolute !important;

        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;

        display: flex !important;

        justify-content: center !important;
        align-items: center !important;

        gap: 10px !important;

        padding: 20px !important;

        z-index: 5 !important;
    }


    /* =====================================
       CONTENT MUST COME AFTER IMAGE
       ===================================== */

    .oq-main-product-content {
        position: relative !important;

        order: 2 !important;

        display: flex !important;
        flex-direction: column !important;

        width: 100% !important;
        min-width: 0 !important;

        height: auto !important;
        min-height: 0 !important;

        box-sizing: border-box !important;

        padding: 40px 24px 0 !important;

        background: #FDFBF4 !important;

        overflow: visible !important;
    }


    /*
     * Prevent the bottom price bar from
     * using desktop negative margins
     */
    .oq-main-product-content > div:last-child {
        margin-left: -24px !important;
        margin-right: -24px !important;
    }

}


/* =========================================
   SMALL PHONES
   ========================================= */

@media screen and (max-width: 480px) {

    .oq-main-product-image-wrap {
        height: 100vw !important;
        min-height: 300px !important;
        max-height: 480px !important;
    }

    .oq-main-product-content {
        padding: 32px 20px 0 !important;
    }

    .oq-main-product-image-wrap .oq-thumbnail-container {
        gap: 7px !important;
        padding: 14px !important;
    }

}
`;

    document.head.appendChild(style);
}

//   ProductQuiz.prototype.renderResults = function () {
//     var meta = this.getMeta();
//     var products = this.getProducts();
//     var ranked = this.computeScores().ranked;
//     var self = this;
//     console.log(ranked);
//       console.log(this.state.category);
//     this.root.classList.add('is-results-active');
//     if (this.el.quizView) this.el.quizView.hidden = true;
//     if (this.el.resultsView) this.el.resultsView.hidden = false;

//     var title = meta.giftTitle
//       ? (this.state.firstName ? this.state.firstName + ', gift sorted.' : 'Gift sorted.')
//       : (this.state.firstName ? this.state.firstName + ', meet' : 'Meet') + ' ' + meta.noun;

//     // if (this.el.resultsHeader) {
//     //   this.el.resultsHeader.innerHTML =
//     //     '<div class="product-quiz-sent-badge"><span></span>' + meta.sentLabel + ' ' + this.escape(this.state.email) + '</div>' +
//     //     '<h2 class="product-quiz-results-title">' + this.escape(title) + '</h2>' +
//     //     '<p class="product-quiz-results-sub">' + this.escape(meta.rSub) + '</p>';
//     // }

//     if (this.el.resultsGrid) {
//       this.el.resultsGrid.innerHTML = '';
//       [0].forEach(function (rank) {
//         var pid = ranked[rank] && ranked[rank].id;
//         if (!pid || !products[pid]) return;
//         var c = products[pid];
//         var card = document.createElement('article');
//         card.className = 'product-quiz-result-card';
//         card.style.animationDelay = (rank * 0.08) + 's';
//         var why = self.reasonsFor(pid).map(function (w) { return '<div class="product-quiz-result-why-item">' + self.escape(w) + '</div>'; }).join('');
//         card.innerHTML = `
// <div style="position:relative;display:flex;flex-direction:column;padding:64px clamp(32px,4.5vw,72px) 0;background:#FDFBF4;">

//     <div style="font:400 11.5px 'Archivo',sans-serif;letter-spacing:.16em;text-transform:uppercase;color:#B0ADA5;margin-bottom:10px;">
//         ${meta.sentLabel} ${this.escape(this.state.email)}
//     </div>

//     <div style="font:400 11.5px 'Archivo',sans-serif;letter-spacing:.13em;text-transform:uppercase;color:#8E8B84;">
//         Your perfect match
//     </div>

//     <a
//         class="oq-hero-title"
//         href="https://www.olympiasaunas.com.au/products/olympia-classic"
//         target="_blank"
//         rel="noopener"
//         style="display:block;font:500 clamp(30px,2.9vw,44px)/1.08 'Archivo',sans-serif;letter-spacing:-.02em;margin:14px 0 4px;color:#111;text-decoration:none;text-underline-offset:6px;"
//     >
//         Classic Steam Sauna
//     </a>

//     <div style="margin-top:20px;font:400 15.5px 'Archivo',sans-serif;color:#5F5F5B;line-height:1.65;max-width:52ch;">
//         The traditional sauna experience. Deep, rolling steam and a Harvia heater at the centre of a ritual that's been practised for generations, built in premium timber for a lifetime of use.
//     </div>

//     <div style="margin-top:30px;display:flex;flex-direction:column;">

//         <div style="display:flex;gap:16px;align-items:flex-start;padding:18px 0;border-top:1px solid #E7E4DC;">
//             <svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 26px;width:26px;height:26px;display:block;">
//                 <path d="M12 2.9c1 2.2 2.4 4 3.9 5.8 1.4 1.7 2.6 3.7 2.6 6 0 3.8-2.7 6.4-6.5 6.4s-6.5-2.6-6.5-6.4c0-2.3 1.2-4.3 2.6-6C9.6 6.9 11 5.1 12 2.9zM12 21.1c-1.9 0-3.2-1.2-3.2-3 0-1.7 1.5-3 3.2-4.8 1.7 1.8 3.2 3.1 3.2 4.8 0 1.8-1.3 3-3.2 3z"></path>
//             </svg>

//             <span style="font:400 14.5px 'Archivo',sans-serif;color:#33312D;line-height:1.55;">
//                 <span style="font-weight:700;">Traditional steam heat</span>
//                 deep, enveloping warmth and rolling steam draw out tension and ease you into deep relaxation
//             </span>
//         </div>

//         <div style="display:flex;gap:16px;align-items:flex-start;padding:18px 0;border-top:1px solid #E7E4DC;">
//             <svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 26px;width:26px;height:26px;display:block;">
//                 <path d="M4.5 20.5v-11h15v11zM4.5 13h15M7.5 9.5V6a1.5 1.5 0 013 0M13.5 9.5V6a1.5 1.5 0 013 0M8 16.5h1.5M14.5 16.5H16"></path>
//             </svg>

//             <span style="font:400 14.5px 'Archivo',sans-serif;color:#33312D;line-height:1.55;">
//                 <span style="font-weight:700;">Harvia heater at its heart</span>
//                 the reliable, proven heater that serious sauna-goers ask for by name
//             </span>
//         </div>

//         <div style="display:flex;gap:16px;align-items:flex-start;padding:18px 0;border-top:1px solid #E7E4DC;">
//             <svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 26px;width:26px;height:26px;display:block;">
//                 <path d="M12 3l5.5 6.5h-3L19 14h-3.5l4 5H4.5l4-5H5l4.5-4.5h-3zM12 19v2.5"></path>
//             </svg>

//             <span style="font:400 14.5px 'Archivo',sans-serif;color:#33312D;line-height:1.55;">
//                 <span style="font-weight:700;">Crafted timber build</span>
//                 Canadian Hemlock outside, thermally treated Poplar inside, framed in tinted tempered glass
//             </span>
//         </div>

//         <div style="display:flex;gap:16px;align-items:flex-start;padding:18px 0;border-top:1px solid #E7E4DC;">
//             <svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 26px;width:26px;height:26px;display:block;">
//                 <path d="M4.5 9.5h15v10h-15zM4.5 13h15M8 6.5l1.5-3 2 2.5 2-2.5 1.5 3M9.5 16.2h.01M12.5 17h.01M14.8 15.8h.01"></path>
//             </svg>

//             <span style="font:400 14.5px 'Archivo',sans-serif;color:#33312D;line-height:1.55;">
//                 <span style="font-weight:700;">Himalayan salt shelf</span>
//                 a large glassed-in salt feature that softens the atmosphere of every session
//             </span>
//         </div>

//     </div>

//     <div style="margin-top:auto;margin-left:clamp(-72px,-4.5vw,-32px);margin-right:clamp(-72px,-4.5vw,-32px);border-top:1px solid #E9E4D6;background:#F8F5EB;padding:22px clamp(32px,4.5vw,72px);display:flex;align-items:center;justify-content:space-between;gap:20px;flex-wrap:wrap;">

//         <div>
//             <div style="font:600 16px 'Archivo',sans-serif;">
//                 Classic Steam Sauna
//             </div>

//             <div style="display:flex;align-items:baseline;gap:10px;margin-top:4px;">
//                 <span style="font:500 17px 'Archivo',sans-serif;color:#C8362A;">
//                     From $3,900
//                 </span>
//             </div>

//             <a
//                 href="https://www.olympiasaunas.com.au/products/olympia-classic"
//                 target="_blank"
//                 rel="noopener"
//                 style="display:inline-block;margin-top:7px;font:400 12.5px 'Archivo',sans-serif;color:#5F5F5B;text-decoration:underline;text-underline-offset:3px;"
//             >
//                 See full details
//             </a>
//         </div>

//         <a
//             href="https://www.olympiasaunas.com.au/products/olympia-classic"
//             target="_blank"
//             rel="noopener"
//             style="text-decoration:none;background:#111;color:#fff;font:600 15px 'Archivo',sans-serif;padding:17px 78px;border-radius:8px;"
//         >
//             Add to cart
//         </a>

//     </div>

// </div>
// `;

//         // card.innerHTML =
//         //   '<div class="product-quiz-result-image"' + (c.img ? ' style="background-image:url(\'' + c.img + '\');background-position:' + (c.imgPos || 'center') + ';"' : '') + '>' +
//         //   '<div class="product-quiz-result-tag ' + (rank === 0 ? 'is-primary' : 'is-secondary') + '">' + (rank === 0 ? meta.tag0 : meta.tag1) + '</div></div>' +
//         //   '<div class="product-quiz-result-body" style="background-color:' + (c.panel || '#333') + ';">' +
//         //   '<div class="product-quiz-result-top">' +
//         //   (c.logoImg ? '<img class="product-quiz-result-logo" src="' + c.logoImg + '" alt="' + self.escape(c.name) + '" style="height:' + (c.logoH || '20px') + '">' :
//         //     '<div><h3 class="product-quiz-result-name">' + self.escape(c.name) + '</h3>' + (c.kind ? '<div class="product-quiz-result-kind">' + self.escape(c.kind) + '</div>' : '') + '</div>') +
//         //   '<div class="product-quiz-result-price-wrap">' +
//         //   (c.was ? '<span class="product-quiz-result-was">' + self.escape(c.was) + '</span>' : '') +
//         //   '<span class="product-quiz-result-price">' + self.escape(c.now || c.priceLabel) + '</span>' +
//         //   '<div class="product-quiz-result-price-sub">' + self.escape(c.weekly ? 'or ' + c.weekly + ' interest free' : (c.priceSub || '')) + '</div></div></div>' +
//         //   '<p class="product-quiz-result-tagline">' + self.escape(c.tagline) + '</p>' +
//         //   '<div class="product-quiz-result-why"><div class="product-quiz-result-why-title">Why it fits</div>' + why + '</div>' +
//         //   '<div class="product-quiz-result-actions">' +
//         //   '<a class="product-quiz-result-btn-primary" href="' + c.url + '">View ' + self.escape(c.name) + '</a>' +
//         //   '<a class="product-quiz-result-btn-secondary" href="#">' + self.escape(meta.cta2) + '</a></div></div>';
//         self.el.resultsGrid.appendChild(card);
//       });
//     }

//     // if (this.el.resultsFooter) {
//     //   this.el.resultsFooter.innerHTML =
//     //     '<div class="product-quiz-assure">' + (meta.assure || []).map(function (a) { return '<span>' + self.escape(a) + '</span>'; }).join('') + '</div>' +
//     //     '<button type="button" class="product-quiz-restart" data-quiz-restart>' + this.escape(meta.restartLabel) + '</button>';
//     //   this.el.resultsFooter.querySelector('[data-quiz-restart]').addEventListener('click', function () { self.restart(); });
//     // }
//   };

  ProductQuiz.prototype.escape = function (s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };

  ProductQuiz.prototype.render = function () {
    if (this.state.done) {
      this.renderResults();
      return;
    }

    this.root.classList.remove('is-results-active');
    if (this.el.quizView) this.el.quizView.hidden = false;
    if (this.el.resultsView) this.el.resultsView.hidden = true;

    var qs = this.getQuestions();
    var meta = this.getMeta();
    var stages = this.getStages();
    var i = this.state.step;
    var isEmail = i >= qs.length;
    var q = isEmail ? null : qs[i];

    this.renderProgress(qs.length, i);

    var stageUrl = '';
    if (isEmail) {
      if (stages.length) stageUrl = stages[stages.length - 1];
    } else {
      if (q && q.stageImage) stageUrl = q.stageImage;
      if (!stageUrl && stages.length) stageUrl = stages[Math.min(i, stages.length - 1)] || stages[stages.length - 1];
    }
    // this.setStageImage(stageUrl);
//     if (
//     isEmail &&
//     this.state.category === 'saunas'
// ) {
//     this.setStageImage('https://cdn.shopify.com/s/files/1/0751/6425/4488/files/5352e57a-a61c-4d0a-8100-2e19655adfe1.jpg?v=1785859046');
// } else {
//     this.setStageImage(stageUrl);
// }

this.setStageImage(
    isEmail
        ? 'https://cdn.shopify.com/s/files/1/0751/6425/4488/files/5352e57a-a61c-4d0a-8100-2e19655adfe1.jpg?v=1785859046'
        : stageUrl
);

    if (this.el.paneInner) {
      this.el.paneInner.style.animation = 'none';
      void this.el.paneInner.offsetWidth;
      this.el.paneInner.style.animation = '';
    }

    if (this.el.eyebrow) this.el.eyebrow.textContent = isEmail ? '' : 'Question ' + (i + 1) + ' of ' + qs.length;
    if (this.el.title) this.el.title.textContent = isEmail ? meta.emailTitle : (q ? q.title : '');
    if (this.el.help) {
      this.el.help.textContent = q && q.help ? q.help : '';
      this.el.help.hidden = isEmail;
    }

    if (this.el.options) {
      if (isEmail) {
        this.el.options.innerHTML = '';
        this.el.options.hidden = true;
        this.el.options.classList.add('is-hidden');
      } else {
        this.el.options.hidden = false;
        this.el.options.classList.remove('is-hidden');
      }
    }
    if (this.el.emailWrap) this.el.emailWrap.hidden = !isEmail;
    if (this.el.nav) this.el.nav.hidden = isEmail;
    if (this.el.backText) this.el.backText.hidden = !isEmail;
    if (this.el.skip) {
  this.el.skip.hidden = !isEmail;
}

    if (!isEmail && q) this.renderOptions(q, this.state.answers[q.id]);

    if (isEmail) {
      if (this.el.emailNote) this.el.emailNote.textContent = meta.emailNote;
      if (this.el.firstName) this.el.firstName.value = this.state.firstName;
      if (this.el.phone) this.el.phone.value = this.state.phone;
      if (this.el.email) this.el.email.value = this.state.email;
    }

    if (this.el.error) {
      this.el.error.hidden = !this.state.err;
      this.el.error.textContent = this.state.err ? (isEmail ? meta.errEmail : meta.errSelect) : '';
    }

    if (this.el.ok) this.el.ok.textContent = isEmail ? meta.okEmail : 'Next';
   
  if (this.el.ok.textContent.trim() != 'Next') {
    document.querySelector('.product-quiz-skip').style.setProperty('display', 'block', 'important');

  }


    if (this.el.next) this.el.next.disabled = !this.stepAnswered();
  };

  ProductQuiz.prototype.bindEvents = function () {
    var self = this;
    if (this.el.ok) this.el.ok.addEventListener('click', function () {
      var qs = self.getQuestions();
      if (self.state.step >= qs.length) self.submitEmail();
      else self.advance();
    });
    if (this.el.prev) this.el.prev.addEventListener('click', function () { self.goBack(); });
    if (this.el.next) this.el.next.addEventListener('click', function () { if (self.stepAnswered()) self.advance(); });
    if (this.el.backText) this.el.backText.addEventListener('click', function () { self.goBack(); });
    if (this.el.skip) {
  this.el.skip.addEventListener('click', function () {
    self.skipEmail();
  });
}
 if (this.el.skip) {
    this.el.skip.addEventListener('click', function () {
      self.skipEmail();
    });
  }

    if (this.el.firstName) this.el.firstName.addEventListener('input', function (e) { self.state.firstName = e.target.value; });
    if (this.el.phone) this.el.phone.addEventListener('input', function (e) { self.state.phone = e.target.value; });
    if (this.el.email) {
      this.el.email.addEventListener('input', function (e) { self.state.email = e.target.value; self.state.err = false; });
      this.el.email.addEventListener('keydown', function (e) { if (e.key === 'Enter') self.submitEmail(); });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quiz-open]');
      if (!trigger) return;
      e.preventDefault();
      var key = trigger.getAttribute('data-quiz-open');
      if (key && window.olympiaQuiz) window.olympiaQuiz.open(key);
    });

    document.addEventListener('keydown', function (e) {
      if (!self.state.category || self.state.done) return;
      if (document.activeElement && document.activeElement.tagName === 'INPUT') return;
      var qs = self.getQuestions();
      if (self.state.step >= qs.length) {
        if (e.key === 'Enter') self.submitEmail();
        return;
      }
      if (e.key === 'Enter') { self.advance(); return; }
      if (e.key === 'ArrowDown') { if (self.stepAnswered()) self.advance(); return; }
      if (e.key === 'ArrowUp') { self.goBack(); return; }
      var idx = KEYS.indexOf(e.key.toUpperCase());
      var q = qs[self.state.step];
      if (idx > -1 && q && q.options[idx]) self.pick(q, q.options[idx].id);
    });
  };

  function initQuiz() {
    var root = document.getElementById('product-quiz-root');
    if (!root || window.olympiaQuiz) return;
    window.olympiaQuiz = new ProductQuiz(root);
    var cfg = readQuizConfig();
    if (cfg.designMode && cfg.editorPreview && cfg.editorPreview !== 'none') {
      var intro = document.querySelector('.shopping-quiz-section');
      if (intro) intro.classList.add('is-quiz-hidden');
      window.olympiaQuiz.open(cfg.editorPreview);
    }
  }
ProductQuiz.prototype.skipEmail = function () {
  if (this.state.submitting) return;

  this.state.err = false;
  this.state.done = true;

  this.render();
  window.scrollTo(0, 0);
};

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuiz);
  } else {
    initQuiz();
  }
})();
